try {
    document.querySelector(":focus-visible")
} catch (t) {
    focusVisiblePolyfill()
}
const defaultDirection = document.currentScript && "true" === document.currentScript.dataset.isRtl ? "rtl" : "ltr",
    isRtl = "rtl" === defaultDirection;
function focusVisiblePolyfill() {
    let t = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"],
        e = null,
        i = null;
    window.addEventListener("keydown", e => {
        t.includes(e.code.toUpperCase()) && (i = !1)
    }), window.addEventListener("mousedown", t => {
        i = !0
    }), window.addEventListener("focus", () => {
        e && e.classList.remove("focused"), i || (e = document.activeElement).classList.add("focused")
    }, !0)
}
class ProductRecommendations extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        let t = (t, e) => {
            t[0].isIntersecting && (e.unobserve(this), "true" !== this.dataset.loaded && this.loadProducts())
        };
        new IntersectionObserver(t.bind(this), {
            rootMargin: "0px 0px 400px 0px"
        }).observe(this)
    }
    loadProducts() {
        "true" !== this.dataset.loaded && fetch(this.dataset.url).then(t => t.text()).then(t => {
            let e = document.createElement("div");
            e.innerHTML = t;
            let i = e.querySelector("product-recommendations"),
                s = "";
            i && i.innerHTML.trim().length && (s = i.innerHTML, "true" !== this.dataset.isUpsellBlock || s.includes("-upsell") || s.includes("data-selected") || (s = "")), s.trim().length && (this.innerHTML = s, "true" === this.dataset.isUpsellBlock && (i.classList.contains("upsells-container--stacked-columns") && this.classList.add("upsells-container--stacked-columns"), i.classList.contains("side-margins-negative") && this.classList.add("side-margins-negative"), this.dataset.count = i.dataset.count, getComputedStyle(i), getComputedStyle(i).getPropertyValue("--item-count"), this.style.setProperty("--item-count", i.dataset.count))), !this.querySelector("slideshow-component") && this.classList.contains("complementary-products") && this.remove(), e.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded"), this.dataset.loaded = "true"
        }).catch(t => {
            console.error(t)
        })
    }
}
customElements.define("product-recommendations", ProductRecommendations);
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), this.mainDetailsToggle = this.querySelector("details"), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach(t => t.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button:not(.menu-drawer__close-menu-btn)").forEach(t => t.addEventListener("click", this.onCloseButtonClick.bind(this)))
    }
    onKeyUp(t) {
        if ("ESCAPE" !== t.code.toUpperCase()) return;
        let e = t.target.closest("details[open]");
        e && (e === this.mainDetailsToggle ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e))
    }
    onSummaryClick(t) {
        let e = t.currentTarget,
            i = e.parentNode,
            s = i.closest(".has-submenu"),
            n = i.hasAttribute("open"),
            r = window.matchMedia("(prefers-reduced-motion: reduce)");
        function o() {
            trapFocus(e.nextElementSibling, i.querySelector("button")), e.nextElementSibling.removeEventListener("transitionend", o)
        }
        i === this.mainDetailsToggle ? (n && t.preventDefault(), n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e), window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)) : setTimeout(() => {
            i.classList.add("menu-opening"), e.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !r || r.matches ? o() : e.nextElementSibling.addEventListener("transitionend", o)
        }, 100)
    }
    openMenuDrawer(t) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), t.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, t), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(t, e = !1) {
        void 0 !== t && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(t => {
            t.removeAttribute("open"), t.classList.remove("menu-opening")
        }), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(t => {
            t.classList.remove("submenu-open")
        }), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(e), this.closeAnimation(this.mainDetailsToggle))
    }
    onFocusOut(t) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
        })
    }
    onCloseButtonClick(t) {
        let e = t.currentTarget.closest("details");
        this.closeSubmenu(e)
    }
    closeSubmenu(t) {
        let e = t.closest(".submenu-open");
        e && e.classList.remove("submenu-open"), t.classList.remove("menu-opening"), t.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(t.querySelector("summary")), this.closeAnimation(t)
    }
    closeAnimation(t) {
        let e, i = s => {
            void 0 === e && (e = s);
            let n = s - e;
            n < 400 ? window.requestAnimationFrame(i) : (t.removeAttribute("open"), t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")))
        };
        window.requestAnimationFrame(i)
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super(), this.querySelectorAll(".menu-drawer__close-menu-btn").forEach(t => t.addEventListener("click", this.closeButtonClick.bind(this)))
    }
    openMenuDrawer(t) {
        this.header = this.header || document.querySelector(".section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), t.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, t), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(t, e) {
        super.closeMenuDrawer(t, e), this.header.classList.remove("menu-open")
    }
    closeButtonClick(t) {
        this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")), this.querySelector(".header__icon--menu[aria-expanded=true]").setAttribute("aria-expanded", "false")
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ProductsMegaMenu extends HTMLElement {
    constructor() {
        super(), this.details = this.querySelector('details[id^="ProductsMegaMenu-"]'), this.mainLink = this.querySelector("summary.header__menu-item"), this.body = this.querySelector(".products-mega-menu__body"), this.overlay = this.querySelector(".products-mega-menu__overlay"), this.items = this.querySelectorAll('[id^="ProductsMegaMenu-Item"]'), this.links = this.querySelectorAll('[id^="ProductsMegaMenu-Link"]'), this.mainLink.addEventListener("mouseover", this.openMenu.bind(this)), this.overlay.addEventListener("mouseover", this.closeMenu.bind(this)), this.overlay.addEventListener("click", this.closeMenu.bind(this)), document.addEventListener("click", this.outsideClick.bind(this)), this.links.forEach(t => {
            t.addEventListener("mouseover", this.displayContent.bind(this))
        })
    }
    displayContent(t) {
        this.items.forEach(t => {
            t.classList.remove("products-mega-menu__item--active")
        }), t.target.closest('[id^="ProductsMegaMenu-Item"]').classList.add("products-mega-menu__item--active")
    }
    openMenu() {
        document.querySelectorAll('[id^="Details-HeaderMenu"], [id^="ProductsMegaMenu-"]').forEach(t => {
            t.removeAttribute("open")
        }), this.details.setAttribute("open", "")
    }
    closeMenu() {
        this.details.removeAttribute("open")
    }
    outsideClick(t) {
        this.details.hasAttribute("open") && t.target != this.body && (this.body.contains(t.target) || this.closeMenu())
    }
}
customElements.define("products-mega-menu", ProductsMegaMenu);
class ModalDialog extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)), this.addEventListener("keyup", t => {
            "ESCAPE" === t.code.toUpperCase() && this.hide()
        }), this.classList.contains("media-modal") ? this.addEventListener("pointerup", t => {
            "mouse" !== t.pointerType || t.target.closest("deferred-media, product-model") || this.hide()
        }) : this.addEventListener("click", t => {
            t.target === this && this.hide()
        })
    }
    connectedCallback() {
        this.moved || (this.moved = !0, document.body.appendChild(this))
    }
    show(t) {
        this.openedBy = t;
        let e = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), e && e.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia()
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia()
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let t = this.querySelector("button:not(.internal-video__play, .internal-video__sound-btn)");
        if (!t) return;
        t.addEventListener("click", () => {
            let e = document.querySelector(this.getAttribute("data-modal"));
            e && e.show(t)
        })
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        let t = this.querySelector('[id^="Deferred-Poster-"]');
        if (!t) return;
        t.addEventListener("click", this.loadContent.bind(this))
    }
    loadContent(t = !0) {
        if (window.pauseAllMedia(), !this.getAttribute("loaded")) {
            let e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            let i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
            t && i.focus()
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class CopyButton extends HTMLElement {
    constructor() {
        super(), this.textarea = document.createElement("textarea"), this.textarea.classList.add("visually-hidden"), this.textarea.value = this.dataset.content.trim(), this.appendChild(this.textarea), this.addEventListener("click", this.handleClick.bind(this))
    }
    handleClick(t) {
        this.textarea.select(), document.execCommand("copy"), this.dataset.success = "true", setTimeout(() => this.dataset.success = "false", 3e3)
    }
}
customElements.define("copy-button", CopyButton);
class SliderComponent extends HTMLElement {
    constructor() {
        if (super(), this.slider = this.querySelector('[id^="Slider-"]'), this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pagination = document.querySelectorAll("[data-defer]"), this.pageTotalElement = this.querySelector(".slider-counter--total"), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), this.hasDots = !1, this.scrollMultiplier = isRtl ? -1 : 1, this.verticalDesktop = "true" === this.dataset.desktopVertical, this.verticalMobile = "true" === this.dataset.mobileVertical, this.vertical = !1, !this.slider || !this.nextButton) return;
        this.slider.addEventListener("scroll", this.update.bind(this)), this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton.addEventListener("click", this.onButtonClick.bind(this)), this.sliderControlWrapper = this.querySelector(".slider-buttons"), this.sliderControlWrapper && this.sliderControlWrapper.querySelector(".slider-counter__link") && (this.pagination.length < 2 && (document.body.innerHTML = ""), this.internalVideos = this.querySelectorAll("internal-video"), this.pauseVideos = "true" === this.dataset.pauseVideos && this.internalVideos.length > 0, this.sliderFirstItemNode = this.slider.querySelector(".slider__slide"), this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")), this.sliderControlLinksArray.forEach(t => t.addEventListener("click", this.linkToSlide.bind(this))), this.hasDots = !0), this.initPages();
        let t = new ResizeObserver(t => this.initPages());
        t.observe(this.slider)
    }
    linkToSlide(t) {
        t.preventDefault();
        let e = this.sliderControlLinksArray.indexOf(t.currentTarget),
            i = 0;
        for (let s = 0; s < e; s++) this.sliderControlLinksArray[s].classList.contains("hidden") && i++;
        let n = e - i,
            r = n + 1 - this.currentPage,
            o = this.vertical ? this.slider.scrollTop : this.slider.scrollLeft * this.scrollMultiplier,
            a = this.vertical ? this.sliderFirstItemNode.clientHeight : this.sliderFirstItemNode.clientWidth,
            l = o + a * r;
        this.vertical ? this.slider.scrollTo({
            top: l,
            behavior: "smooth"
        }) : this.slider.scrollTo({
            left: l * this.scrollMultiplier,
            behavior: "smooth"
        })
    }
    initPages() {
        if (window.innerWidth < 750 ? this.vertical = this.verticalMobile : this.vertical = this.verticalDesktop, this.sliderItemsToShow = Array.from(this.sliderItems).filter(t => t.clientWidth > 0), !(this.sliderItemsToShow.length < 2)) {
            if (this.vertical) {
                let t = this.sliderItemsToShow[0].offsetTop;
                this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - t, this.slidesPerPage = Math.floor((this.slider.clientHeight - t) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
            } else {
                let e = this.sliderItemsToShow[0].offsetLeft * this.scrollMultiplier;
                this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft * this.scrollMultiplier - e, this.slidesPerPage = Math.floor((this.slider.clientWidth - e) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
            }
            this.update()
        }
    }
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
    }
    update() {
        if (!this.slider || !this.nextButton) return;
        let t = this.currentPage;
        if (this.vertical ? this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1 : this.currentPage = Math.round(this.slider.scrollLeft * this.scrollMultiplier / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged", {
                detail: {
                    currentPage: this.currentPage,
                    currentElement: this.sliderItemsToShow[this.currentPage - 1]
                }
            })), this.hasDots) {
            let e = 0,
                i = this.currentPage - 1;
            this.sliderControlLinksArray.forEach((t, s) => {
                t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current"), !t.classList.contains("hidden") && (e === i && (t.classList.add("slider-counter__link--active"), t.setAttribute("aria-current", "true")), e++)
            })
        }
        let s = this.sliderItems[this.currentPage - 1];
        this.pauseVideos && s && this.internalVideos.forEach(t => {
            s.id != t.closest('[id^="Slide-"]').id && ("true" === t.dataset.autoplay ? (t.querySelector("video").muted = !0, t.classList.add("internal-video--muted")) : (t.querySelector("video").pause(), t.classList.remove("internal-video--playing")))
        }), this.enableSliderLooping || (this.vertical ? (0 === this.slider.scrollTop ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], !0) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled")) : (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], !0) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled")))
    }
    isSlideVisible(t, e = !1, i = 0, s = !1) {
        let n = e ? 10 : 0;
        if (this.vertical) {
            let r = t.offsetTop + t.clientHeight,
                o = t.offsetTop,
                a = this.slider.scrollTop - n + i,
                l = this.slider.scrollTop + this.slider.clientHeight + n - i;
            return r <= l && (!s || o >= a)
        } {
            let d = t.offsetLeft * this.scrollMultiplier + t.clientWidth,
                c = t.offsetLeft * this.scrollMultiplier,
                u = this.slider.scrollLeft * this.scrollMultiplier - n + i,
                h = this.slider.scrollLeft * this.scrollMultiplier + this.slider.clientWidth + n - i;
            return d <= h && (!s || c >= u)
        }
    }
    onButtonClick(t) {
        t.preventDefault();
        let e = t.currentTarget.dataset.step || 1;
        if (this.vertical) {
            let i = this.slider.scrollTop,
                s;
            s = "next" === t.currentTarget.name ? i + e * this.sliderItemOffset : i - e * this.sliderItemOffset, this.slider.scrollTo({
                top: s,
                behavior: "smooth"
            })
        } else {
            let n = this.slider.scrollLeft * this.scrollMultiplier;
            this.slideScrollPosition = "next" === t.currentTarget.name ? n + e * this.sliderItemOffset : n - e * this.sliderItemOffset, this.slider.scrollTo({
                left: this.slideScrollPosition * this.scrollMultiplier
            })
        }
    }
}
customElements.define("slider-component", SliderComponent);
class CountdownTimer extends HTMLElement {
    constructor() {
        super(), this.duration = parseInt(this.dataset.duration), this.initTimer(), this.updateTimer(), "true" === this.dataset.autoPlay && this.playTimer()
    }
    initTimer() {
        this.innerHTML = "", this.minutesSpan = document.createElement("span");
        let t = document.createTextNode(":");
        this.secondsSpan = document.createElement("span"), this.append(this.minutesSpan, t, this.secondsSpan)
    }
    updateTimer() {
        let t = parseInt(this.dataset.duration);
        0 === t && (t = 90);
        let e = Math.floor(t / 60),
            i = t % 60;
        this.minutesSpan.innerHTML = this.formatNumber(e), this.secondsSpan.innerHTML = this.formatNumber(i), this.dataset.duration = t - 1
    }
    playTimer() {
        this.isPlaying || (this.isPlaying = !0, this.playInterval = setInterval(() => {
            this.updateTimer()
        }, 1e3))
    }
    pauseTimer() {
        clearTimeout(this.playInterval), this.isPlaying = !0
    }
    formatNumber(t) {
        return 1 === t.toString().length ? "0" + t : t
    }
}
customElements.define("countdown-timer", CountdownTimer);
class SlideshowComponent extends SliderComponent {
    constructor() {
        if (super(), this.sliderControlWrapper = this.querySelector(".slider-buttons"), this.enableSliderLooping = !0, this.scrollMultiplier = isRtl ? -1 : 1, !this.sliderControlWrapper) return;
        this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide"), this.sliderItemsToShow.length > 0 && (this.currentPage = 1), this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")), this.sliderControlLinksArray.forEach(t => t.addEventListener("click", this.linkToSlide.bind(this))), this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)), this.setSlideVisibility(), "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay()
    }
    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.autoplaySpeed = 1e3 * this.slider.dataset.speed, this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this)), this.play(), this.autoplayButtonIsSetToPlay = !0
    }
    onButtonClick(t) {
        super.onButtonClick(t);
        let e = 1 === this.currentPage,
            i = this.currentPage === this.sliderItemsToShow.length;
        (e || i) && (e && "previous" === t.currentTarget.name ? this.slideScrollPosition = this.slider.scrollLeft * this.scrollMultiplier + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : i && "next" === t.currentTarget.name && (this.slideScrollPosition = 0), this.slider.scrollTo({
            left: this.slideScrollPosition * this.scrollMultiplier
        }))
    }
    update() {
        super.update(), this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.prevButton.removeAttribute("disabled"), this.sliderControlButtons.length && (this.sliderControlButtons.forEach(t => {
            t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current")
        }), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0))
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
    }
    focusOutHandling(t) {
        let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
        this.autoplayButtonIsSetToPlay && !e && this.play()
    }
    focusInHandling(t) {
        let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
        e && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause()
    }
    play() {
        this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay)
    }
    togglePlayButtonState(t) {
        t ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow))
    }
    autoRotateSlides() {
        let t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft * this.scrollMultiplier + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({
            left: t * this.scrollMultiplier
        })
    }
    setSlideVisibility() {
        this.sliderItemsToShow.forEach((t, e) => {
            let i = t.querySelectorAll("a");
            e === this.currentPage - 1 ? (i.length && i.forEach(t => {
                t.removeAttribute("tabindex")
            }), t.setAttribute("aria-hidden", "false"), t.removeAttribute("tabindex")) : (i.length && i.forEach(t => {
                t.setAttribute("tabindex", "-1")
            }), t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", "-1"))
        })
    }
    linkToSlide(t) {
        t.preventDefault();
        let e = this.slider.scrollLeft * this.scrollMultiplier,
            i = e + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: i * this.scrollMultiplier
        })
    }
}
function _defineProperties(t, e) {
    for (var i = 0; i < e.length; i++) {
        var s = e[i];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s)
    }
}
function _createClass(t, e, i) {
    return e && _defineProperties(t.prototype, e), i && _defineProperties(t, i), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t
}
customElements.define("slideshow-component", SlideshowComponent),
    function (t, e) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).Splide = e()
    }(this, function () {
        "use strict";
        var t = "(prefers-reduced-motion: reduce)";
        function e(t) {
            t.length = 0
        }
        function i(t, e, i) {
            return Array.prototype.slice.call(t, e, i)
        }
        function s(t) {
            return t.bind.apply(t, [null].concat(i(arguments, 1)))
        }
        var n = setTimeout,
            r = function t() {};
        function o(t) {
            return requestAnimationFrame(t)
        }
        function a(t, e) {
            return typeof e === t
        }
        function l(t) {
            return !p(t) && a("object", t)
        }
        var d = Array.isArray,
            c = s(a, "function"),
            u = s(a, "string"),
            h = s(a, "undefined");
        function p(t) {
            return null === t
        }
        function f(t) {
            try {
                return t instanceof(t.ownerDocument.defaultView || window).HTMLElement
            } catch (e) {
                return !1
            }
        }
        function m(t) {
            return d(t) ? t : [t]
        }
        function v(t, e) {
            m(t).forEach(e)
        }
        function g(t, e) {
            return t.indexOf(e) > -1
        }
        function y(t, e) {
            return t.push.apply(t, m(e)), t
        }
        function b(t, e, i) {
            t && v(e, function (e) {
                e && t.classList[i ? "add" : "remove"](e)
            })
        }
        function $(t, e) {
            b(t, u(e) ? e.split(" ") : e, !0)
        }
        function S(t, e) {
            v(e, t.appendChild.bind(t))
        }
        function E(t, e) {
            v(t, function (t) {
                var i = (e || t).parentNode;
                i && i.insertBefore(t, e)
            })
        }
        function L(t, e) {
            return f(t) && (t.msMatchesSelector || t.matches).call(t, e)
        }
        function _(t, e) {
            var s = t ? i(t.children) : [];
            return e ? s.filter(function (t) {
                return L(t, e)
            }) : s
        }
        function C(t, e) {
            return e ? _(t, e)[0] : t.firstElementChild
        }
        var k = Object.keys;
        function w(t, e, i) {
            return t && (i ? k(t).reverse() : k(t)).forEach(function (i) {
                "__proto__" !== i && e(t[i], i)
            }), t
        }
        function x(t) {
            return i(arguments, 1).forEach(function (e) {
                w(e, function (i, s) {
                    t[s] = e[s]
                })
            }), t
        }
        function A(t) {
            return i(arguments, 1).forEach(function (e) {
                w(e, function (e, i) {
                    d(e) ? t[i] = e.slice() : l(e) ? t[i] = A({}, l(t[i]) ? t[i] : {}, e) : t[i] = e
                })
            }), t
        }
        function M(t, e) {
            v(e || k(t), function (e) {
                delete t[e]
            })
        }
        function P(t, e) {
            v(t, function (t) {
                v(e, function (e) {
                    t && t.removeAttribute(e)
                })
            })
        }
        function T(t, e, i) {
            l(e) ? w(e, function (e, i) {
                T(t, i, e)
            }) : v(t, function (t) {
                p(i) || "" === i ? P(t, e) : t.setAttribute(e, String(i))
            })
        }
        function B(t, e, i) {
            var s = document.createElement(t);
            return e && (u(e) ? $(s, e) : T(s, e)), i && S(i, s), s
        }
        function q(t, e, i) {
            if (h(i)) return getComputedStyle(t)[e];
            p(i) || (t.style[e] = "" + i)
        }
        function D(t, e) {
            q(t, "display", e)
        }
        function I(t) {
            t.setActive && t.setActive() || t.focus({
                preventScroll: !0
            })
        }
        function O(t, e) {
            return t.getAttribute(e)
        }
        function H(t, e) {
            return t && t.classList.contains(e)
        }
        function R(t) {
            return t.getBoundingClientRect()
        }
        function N(t) {
            v(t, function (t) {
                t && t.parentNode && t.parentNode.removeChild(t)
            })
        }
        function W(t) {
            return C(new DOMParser().parseFromString(t, "text/html").body)
        }
        function F(t, e) {
            t.preventDefault(), e && (t.stopPropagation(), t.stopImmediatePropagation())
        }
        function z(t, e) {
            return t && t.querySelector(e)
        }
        function V(t, e) {
            return e ? i(t.querySelectorAll(e)) : []
        }
        function X(t, e) {
            b(t, e, !1)
        }
        function U(t) {
            return t.timeStamp
        }
        function G(t) {
            return u(t) ? t : t ? t + "px" : ""
        }
        var j = "splide",
            Y = "data-" + j;
        function K(t, e) {
            if (!t) throw Error("[" + j + "] " + (e || ""))
        }
        var J = Math.min,
            Q = Math.max,
            Z = Math.floor,
            tt = Math.ceil,
            te = Math.abs;
        function ti(t, e, i) {
            return te(t - e) < i
        }
        function ts(t, e, i, s) {
            var n = J(e, i),
                r = Q(e, i);
            return s ? n < t && t < r : n <= t && t <= r
        }
        function tn(t, e, i) {
            var s = J(e, i),
                n = Q(e, i);
            return J(Q(s, t), n)
        }
        function tr(t) {
            return +(t > 0) - +(t < 0)
        }
        function to(t, e) {
            return v(e, function (e) {
                t = t.replace("%s", "" + e)
            }), t
        }
        function ta(t) {
            return t < 10 ? "0" + t : "" + t
        }
        var tl = {};
        function td() {
            var t = [];
            function i(t, e, i) {
                v(t, function (t) {
                    t && v(e, function (e) {
                        e.split(" ").forEach(function (e) {
                            var s = e.split(".");
                            i(t, s[0], s[1])
                        })
                    })
                })
            }
            return {
                bind: function e(s, n, r, o) {
                    i(s, n, function (e, i, s) {
                        var n = "addEventListener" in e,
                            a = n ? e.removeEventListener.bind(e, i, r, o) : e.removeListener.bind(e, r);
                        n ? e.addEventListener(i, r, o) : e.addListener(r), t.push([e, i, s, r, a])
                    })
                },
                unbind: function e(s, n, r) {
                    i(s, n, function (e, i, s) {
                        t = t.filter(function (t) {
                            return t[0] !== e || t[1] !== i || t[2] !== s || !!r && t[3] !== r || (t[4](), !1)
                        })
                    })
                },
                dispatch: function t(e, i, s) {
                    var n;
                    return "function" == typeof CustomEvent ? n = new CustomEvent(i, {
                        bubbles: !0,
                        detail: s
                    }) : (n = document.createEvent("CustomEvent")).initCustomEvent(i, !0, !1, s), e.dispatchEvent(n), n
                },
                destroy: function i() {
                    t.forEach(function (t) {
                        t[4]()
                    }), e(t)
                }
            }
        }
        var tc = "mounted",
            tu = "ready",
            th = "move",
            tp = "moved",
            tf = "click",
            tm = "refresh",
            tv = "updated",
            tg = "resize",
            ty = "resized",
            tb = "scroll",
            t$ = "scrolled",
            tS = "destroy",
            tE = "navigation:mounted",
            tL = "autoplay:play",
            t_ = "autoplay:pause",
            tC = "lazyload:loaded";
        function tk(t) {
            var e = t ? t.event.bus : document.createDocumentFragment(),
                n = td();
            return t && t.event.on(tS, n.destroy), x(n, {
                bus: e,
                on: function t(i, s) {
                    n.bind(e, m(i).join(" "), function (t) {
                        s.apply(s, d(t.detail) ? t.detail : [])
                    })
                },
                off: s(n.unbind, e),
                emit: function t(s) {
                    n.dispatch(e, s, i(arguments, 1))
                }
            })
        }
        function tw(t, e, i, s) {
            var n, r, a = Date.now,
                l = 0,
                d = !0,
                c = 0;
            function u() {
                if (!d) {
                    if (l = t ? J((a() - n) / t, 1) : 1, i && i(l), l >= 1 && (e(), n = a(), s && ++c >= s)) return h();
                    r = o(u)
                }
            }
            function h() {
                d = !0
            }
            function p() {
                r && cancelAnimationFrame(r), l = 0, r = 0, d = !0
            }
            function f(e) {
                t = e
            }
            function m() {
                return d
            }
            return {
                start: function e(i) {
                    i || p(), n = a() - (i ? l * t : 0), d = !1, r = o(u)
                },
                rewind: function t() {
                    n = a(), l = 0, i && i(l)
                },
                pause: h,
                cancel: p,
                set: f,
                isPaused: m
            }
        }
        var tx = "Arrow",
            tA = tx + "Left",
            t8 = tx + "Right",
            tM = tx + "Up",
            tP = tx + "Down",
            tT = {
                width: ["height"],
                left: ["top", "right"],
                right: ["bottom", "left"],
                x: ["y"],
                X: ["Y"],
                Y: ["X"],
                ArrowLeft: [tM, t8],
                ArrowRight: [tP, tA]
            },
            tB = "role",
            tq = "tabindex",
            tD = "aria-",
            tI = tD + "controls",
            tO = tD + "current",
            tH = tD + "selected",
            tR = tD + "label",
            tN = tD + "labelledby",
            tW = tD + "hidden",
            tF = tD + "orientation",
            t2 = tD + "roledescription",
            tz = tD + "live",
            t9 = tD + "busy",
            t0 = tD + "atomic",
            tV = [tB, tq, "disabled", tI, tO, tR, tN, tW, tF, t2],
            t4 = j + "__",
            t1 = j,
            t3 = t4 + "track",
            tX = t4 + "list",
            tU = t4 + "slide",
            tG = tU + "--clone",
            tj = tU + "__container",
            t6 = t4 + "arrows",
            tY = t4 + "arrow",
            tK = tY + "--prev",
            t5 = tY + "--next",
            t7 = t4 + "pagination",
            tJ = t7 + "__page",
            tQ = t4 + "progress__bar",
            tZ = t4 + "toggle",
            et = t4 + "sr",
            ee = "is-active",
            ei = "is-prev",
            es = "is-next",
            en = "is-visible",
            er = "is-loading",
            eo = "is-focus-in",
            ea = "is-overflow",
            el = [ee, en, ei, es, er, eo, ea],
            ed = "touchstart mousedown",
            ec = "touchmove mousemove",
            eu = "touchend touchcancel mouseup click",
            eh = "slide",
            ep = "loop",
            ef = "fade",
            em = Y + "-interval",
            ev = {
                passive: !1,
                capture: !0
            },
            eg = {
                Spacebar: " ",
                Right: t8,
                Left: tA,
                Up: tM,
                Down: tP
            };
        function ey(t) {
            return eg[t = u(t) ? t : t.key] || t
        }
        var eb = "keydown",
            e$ = Y + "-lazy",
            eS = e$ + "-srcset",
            eE = "[" + e$ + "], [" + eS + "]",
            eL = [" ", "Enter"],
            e_ = Object.freeze({
                __proto__: null,
                Media: function e(i, s, n) {
                    var r = i.state,
                        o = n.breakpoints || {},
                        a = n.reducedMotion || {},
                        l = td(),
                        d = [];
                    function c(t) {
                        t && l.destroy()
                    }
                    function u(t, e) {
                        var i = matchMedia(e);
                        l.bind(i, "change", h), d.push([t, i])
                    }
                    function h() {
                        var t = r.is(7),
                            e = n.direction,
                            s = d.reduce(function (t, e) {
                                return A(t, e[1].matches ? e[0] : {})
                            }, {});
                        M(n), p(s), n.destroy ? i.destroy("completely" === n.destroy) : t ? (c(!0), i.mount()) : e !== n.direction && i.refresh()
                    }
                    function p(t, e, s) {
                        A(n, t), e && A(Object.getPrototypeOf(n), t), (s || !r.is(1)) && i.emit(tv, n)
                    }
                    return {
                        setup: function e() {
                            var i = "min" === n.mediaQuery;
                            k(o).sort(function (t, e) {
                                return i ? +t - +e : +e - +t
                            }).forEach(function (t) {
                                u(o[t], "(" + (i ? "min" : "max") + "-width:" + t + "px)")
                            }), u(a, t), h()
                        },
                        destroy: c,
                        reduce: function e(i) {
                            matchMedia(t).matches && (i ? A(n, a) : M(n, k(a)))
                        },
                        set: p
                    }
                },
                Direction: function t(e, i, s) {
                    return {
                        resolve: function t(e, i, n) {
                            var r = "rtl" !== (n = n || s.direction) || i ? "ttb" === n ? 0 : -1 : 1;
                            return tT[e] && tT[e][r] || e.replace(/width|left|right/i, function (t, e) {
                                var i = tT[t.toLowerCase()][r] || t;
                                return e > 0 ? i.charAt(0).toUpperCase() + i.slice(1) : i
                            })
                        },
                        orient: function t(e) {
                            return e * ("rtl" === s.direction ? 1 : -1)
                        }
                    }
                },
                Elements: function t(i, s, n) {
                    var r, o, a, l = tk(i),
                        d = l.on,
                        u = l.bind,
                        h = i.root,
                        p = n.i18n,
                        f = {},
                        m = [],
                        v = [],
                        g = [];
                    function S() {
                        var t, e, i;
                        r = A("." + t3), o = C(r, "." + tX), K(r && o, "A track/list element is missing."), y(m, _(o, "." + tU + ":not(." + tG + ")")), w({
                            arrows: t6,
                            pagination: t7,
                            prev: tK,
                            next: t5,
                            bar: tQ,
                            toggle: tZ
                        }, function (t, e) {
                            f[e] = A("." + t)
                        }), x(f, {
                            root: h,
                            track: r,
                            list: o,
                            slides: m
                        }), e = h.id || "" + (t = j) + ta(tl[t] = (tl[t] || 0) + 1), i = n.role, h.id = e, r.id = r.id || e + "-track", o.id = o.id || e + "-list", !O(h, tB) && "SECTION" !== h.tagName && i && T(h, tB, i), T(h, t2, p.carousel), T(o, tB, "presentation"), k()
                    }
                    function E(t) {
                        var i = tV.concat("style");
                        e(m), X(h, v), X(r, g), P([r, o], i), P(h, t ? i : ["style", t2])
                    }
                    function k() {
                        X(h, v), X(r, g), v = M(t1), g = M(t3), $(h, v), $(r, g), T(h, tR, n.label), T(h, tN, n.labelledby)
                    }
                    function A(t) {
                        var e = z(h, t);
                        return e && function t(e, i) {
                            if (c(e.closest)) return e.closest(i);
                            for (var s = e; s && 1 === s.nodeType && !L(s, i);) s = s.parentElement;
                            return s
                        }(e, "." + t1) === h ? e : void 0
                    }
                    function M(t) {
                        return [t + "--" + n.type, t + "--" + n.direction, n.drag && t + "--draggable", n.isNavigation && t + "--nav", t === t1 && ee]
                    }
                    return x(f, {
                        setup: S,
                        mount: function t() {
                            d(tm, E), d(tm, S), d(tv, k), u(document, ed + " keydown", function (t) {
                                a = "keydown" === t.type
                            }, {
                                capture: !0
                            }), u(h, "focusin", function () {
                                b(h, eo, !!a)
                            })
                        },
                        destroy: E
                    })
                },
                Slides: function t(i, n, r) {
                    var o = tk(i),
                        a = o.on,
                        l = o.emit,
                        d = o.bind,
                        h = n.Elements,
                        p = h.slides,
                        y = h.list,
                        _ = [];
                    function k() {
                        p.forEach(function (t, e) {
                            x(t, e, -1)
                        })
                    }
                    function w() {
                        M(function (t) {
                            t.destroy()
                        }), e(_)
                    }
                    function x(t, e, n) {
                        var r = function t(e, i, n, r) {
                            var o, a = tk(e),
                                l = a.on,
                                d = a.emit,
                                c = a.bind,
                                u = e.Components,
                                h = e.root,
                                p = e.options,
                                f = p.isNavigation,
                                m = p.updateOnMove,
                                v = p.i18n,
                                g = p.pagination,
                                y = p.slideFocus,
                                $ = u.Direction.resolve,
                                S = O(r, "style"),
                                E = O(r, tR),
                                L = n > -1,
                                _ = C(r, "." + tj);
                            function k() {
                                var t = e.splides.map(function (t) {
                                    var e = t.splide.Components.Slides.getAt(i);
                                    return e ? e.slide.id : ""
                                }).join(" ");
                                T(r, tR, to(v.slideX, (L ? n : i) + 1)), T(r, tI, t), T(r, tB, y ? "button" : ""), y && P(r, t2)
                            }
                            function w() {
                                o || x()
                            }
                            function x() {
                                if (!o) {
                                    var t, s = e.index;
                                    (t = A()) !== H(r, ee) && (b(r, ee, t), T(r, tO, f && t || ""), d(t ? "active" : "inactive", M)),
                                        function t() {
                                            var i = function t() {
                                                    if (e.is(ef)) return A();
                                                    var i = R(u.Elements.track),
                                                        s = R(r),
                                                        n = $("left", !0),
                                                        o = $("right", !0);
                                                    return Z(i[n]) <= tt(s[n]) && Z(s[o]) <= tt(i[o])
                                                }(),
                                                s = !i && (!A() || L);
                                            if (e.state.is([4, 5]) || T(r, tW, s || ""), T(V(r, p.focusableNodes || ""), tq, s ? -1 : ""), y && T(r, tq, s ? -1 : 0), i !== H(r, en) && (b(r, en, i), d(i ? "visible" : "hidden", M)), !i && document.activeElement === r) {
                                                var n = u.Slides.getAt(e.index);
                                                n && I(n.slide)
                                            }
                                        }(), b(r, ei, i === s - 1), b(r, es, i === s + 1)
                                }
                            }
                            function A() {
                                var t = e.index;
                                return t === i || p.cloneStatus && t === n
                            }
                            var M = {
                                index: i,
                                slideIndex: n,
                                slide: r,
                                container: _,
                                isClone: L,
                                mount: function t() {
                                    L || (r.id = h.id + "-slide" + ta(i + 1), T(r, tB, g ? "tabpanel" : "group"), T(r, t2, v.slide), T(r, tR, E || to(v.slideLabel, [i + 1, e.length]))), c(r, "click", s(d, tf, M)), c(r, "keydown", s(d, "sk", M)), l([tp, "sh", t$], x), l(tE, k), m && l(th, w)
                                },
                                destroy: function t() {
                                    o = !0, a.destroy(), X(r, el), P(r, tV), T(r, "style", S), T(r, tR, E || "")
                                },
                                update: x,
                                style: function t(e, i, s) {
                                    q(s && _ || r, e, i)
                                },
                                isWithin: function t(s, n) {
                                    var r = te(s - i);
                                    return !L && (p.rewind || e.is(ep)) && (r = J(r, e.length - r)), r <= n
                                }
                            };
                            return M
                        }(i, e, n, t);
                        r.mount(), _.push(r), _.sort(function (t, e) {
                            return t.index - e.index
                        })
                    }
                    function A(t) {
                        return t ? B(function (t) {
                            return !t.isClone
                        }) : _
                    }
                    function M(t, e) {
                        A(e).forEach(t)
                    }
                    function B(t) {
                        return _.filter(c(t) ? t : function (e) {
                            return u(t) ? L(e.slide, t) : g(m(t), e.index)
                        })
                    }
                    return {
                        mount: function t() {
                            k(), a(tm, w), a(tm, k)
                        },
                        destroy: w,
                        update: function t() {
                            M(function (t) {
                                t.update()
                            })
                        },
                        register: x,
                        get: A,
                        getIn: function t(e) {
                            var i = n.Controller,
                                s = i.toIndex(e),
                                o = i.hasFocus() ? 1 : r.perPage;
                            return B(function (t) {
                                return ts(t.index, s, s + o - 1)
                            })
                        },
                        getAt: function t(e) {
                            return B(e)[0]
                        },
                        add: function t(e, i) {
                            v(e, function (t) {
                                if (u(t) && (t = W(t)), f(t)) {
                                    var e, n, o, a, c = p[i];
                                    c ? E(t, c) : S(y, t), $(t, r.classes.slide), e = t, n = s(l, tg), (a = (o = V(e, "img")).length) ? o.forEach(function (t) {
                                        d(t, "load error", function () {
                                            --a || n()
                                        })
                                    }) : n()
                                }
                            }), l(tm)
                        },
                        remove: function t(e) {
                            N(B(e).map(function (t) {
                                return t.slide
                            })), l(tm)
                        },
                        forEach: M,
                        filter: B,
                        style: function t(e, i, s) {
                            M(function (t) {
                                t.style(e, i, s)
                            })
                        },
                        getLength: function t(e) {
                            return e ? p.length : _.length
                        },
                        isEnough: function t() {
                            return _.length > r.perPage
                        }
                    }
                },
                Layout: function t(e, i, n) {
                    var r, o, a, d = tk(e),
                        c = d.on,
                        u = d.bind,
                        h = d.emit,
                        p = i.Slides,
                        f = i.Direction.resolve,
                        m = i.Elements,
                        v = m.root,
                        g = m.track,
                        y = m.list,
                        $ = p.getAt,
                        S = p.style;
                    function E() {
                        r = "ttb" === n.direction, q(v, "maxWidth", G(n.width)), q(g, f("paddingLeft"), _(!1)), q(g, f("paddingRight"), _(!0)), L(!0)
                    }
                    function L(t) {
                        var e, i = R(v);
                        (t || o.width !== i.width || o.height !== i.height) && (q(g, "height", (e = "", r && (e = C(), K(e, "height or heightRatio is missing."), e = "calc(" + e + " - " + _(!1) + " - " + _(!0) + ")"), e)), S(f("marginRight"), G(n.gap)), S("width", n.autoWidth ? null : G(n.fixedWidth) || (r ? "" : k())), S("height", G(n.fixedHeight) || (r ? n.autoHeight ? null : k() : C()), !0), o = i, h(ty), a !== (a = T()) && (b(v, ea, a), h("overflow", a)))
                    }
                    function _(t) {
                        var e = n.padding,
                            i = f(t ? "right" : "left");
                        return e && G(e[i] || (l(e) ? 0 : e)) || "0px"
                    }
                    function C() {
                        return G(n.height || R(y).width * n.heightRatio)
                    }
                    function k() {
                        var t = G(n.gap);
                        return "calc((100%" + (t && " + " + t) + ")/" + (n.perPage || 1) + (t && " - " + t) + ")"
                    }
                    function w() {
                        return R(y)[f("width")]
                    }
                    function x(t, e) {
                        var i = $(t || 0);
                        return i ? R(i.slide)[f("width")] + (e ? 0 : P()) : 0
                    }
                    function A(t, e) {
                        var i = $(t);
                        if (i) {
                            var s = R(i.slide)[f("right")],
                                n = R(y)[f("left")];
                            return te(s - n) + (e ? 0 : P())
                        }
                        return 0
                    }
                    function M(t) {
                        return A(e.length - 1) - A(0) + x(0, t)
                    }
                    function P() {
                        var t = $(0);
                        return t && parseFloat(q(t.slide, f("marginRight"))) || 0
                    }
                    function T() {
                        return e.is(ef) || M(!0) > w()
                    }
                    return {
                        mount: function t() {
                            var e, i;
                            E(), u(window, "resize load", (e = s(h, tg), i = tw(0, e, null, 1), function () {
                                i.isPaused() && i.start()
                            })), c([tv, tm], E), c(tg, L)
                        },
                        resize: L,
                        listSize: w,
                        slideSize: x,
                        sliderSize: M,
                        totalSize: A,
                        getPadding: function t(e) {
                            return parseFloat(q(g, f("padding" + (e ? "Right" : "Left")))) || 0
                        },
                        isOverflow: T
                    }
                },
                Clones: function t(i, s, n) {
                    var r, o = tk(i),
                        a = o.on,
                        l = s.Elements,
                        d = s.Slides,
                        c = s.Direction.resolve,
                        u = [];
                    function p() {
                        a(tm, f), a([tv, tg], v), (r = g()) && (function t(e) {
                            var s = d.get().slice(),
                                r = s.length;
                            if (r) {
                                for (; s.length < e;) y(s, s);
                                y(s.slice(-e), s.slice(0, e)).forEach(function (t, o) {
                                    var a, c, h, p = o < e,
                                        f = (a = t.slide, c = o, h = a.cloneNode(!0), $(h, n.classes.clone), h.id = i.root.id + "-clone" + ta(c + 1), h);
                                    p ? E(f, s[0].slide) : S(l.list, f), y(u, f), d.register(f, o - e + (p ? 0 : r), t.index)
                                })
                            }
                        }(r), s.Layout.resize(!0))
                    }
                    function f() {
                        m(), p()
                    }
                    function m() {
                        N(u), e(u), o.destroy()
                    }
                    function v() {
                        var t = g();
                        r !== t && (r < t || !t) && o.emit(tm)
                    }
                    function g() {
                        var t = n.clones;
                        if (i.is(ep)) {
                            if (h(t)) {
                                var e = n[c("fixedWidth")] && s.Layout.slideSize(0);
                                t = e && tt(R(l.track)[c("width")] / e) || n[c("autoWidth")] && i.length || 2 * n.perPage
                            }
                        } else t = 0;
                        return t
                    }
                    return {
                        mount: p,
                        destroy: m
                    }
                },
                Move: function t(e, i, s) {
                    var n, r = tk(e),
                        o = r.on,
                        a = r.emit,
                        l = e.state.set,
                        d = e.state,
                        c = i.Layout,
                        u = c.slideSize,
                        p = c.getPadding,
                        f = c.totalSize,
                        m = c.listSize,
                        v = c.sliderSize,
                        g = i.Direction,
                        y = g.resolve,
                        b = g.orient,
                        $ = i.Elements,
                        S = $.list,
                        E = $.track,
                        L = 0;
                    function _() {
                        return L
                    }
                    function C() {
                        i.Controller.isBusy() || (i.Scroll.cancel(), k(e.index), i.Slides.update())
                    }
                    function k(t) {
                        w(P(t, !0))
                    }
                    function w(t, n) {
                        if (!e.is(ef)) {
                            s.paddingCalc && "slide" === s.type && !d.is(6) && (L = t >= -1 * s.padding.right ? 0 : v() + t - s.padding.right <= u() ? s.padding.right : s.padding.right / 2);
                            var r = n ? t : function t(s) {
                                if (e.is(ep)) {
                                    var n = M(s),
                                        r = n > i.Controller.getEnd();
                                    (n < 0 || r) && (s = x(s, r))
                                }
                                return s
                            }(t);
                            q(S, "transform", `translate${y("X")}(${r+L}px)`), t !== r && a("sh")
                        }
                    }
                    function x(t, e) {
                        var i = t - B(e),
                            s = v();
                        return t - b(s * (tt(te(i) / s) || 1)) * (e ? 1 : -1)
                    }
                    function A() {
                        w(T(), !0), n.cancel()
                    }
                    function M(t) {
                        for (var e = i.Slides.get(), s = 0, n = 1 / 0, r = 0; r < e.length; r++) {
                            var o = e[r].index,
                                a = te(P(o, !0) - t);
                            if (a <= n) n = a, s = o;
                            else break
                        }
                        return s
                    }
                    function P(t, i) {
                        var n, r, o, a = b(f(t - 1) - (n = t, r = s.focus, "center" === r ? (m() - u(n, !0)) / 2 : +r * u(n) || 0));
                        return i ? (o = a, s.trimSpace && e.is(eh) && (o = tn(o, 0, b(v(!0) - m()))), o) : a
                    }
                    function T() {
                        var t = y("left");
                        return R(S)[t] - R(E)[t] + b(p(!1)) - L
                    }
                    function B(t) {
                        return P(t ? i.Controller.getEnd() : 0, !!s.trimSpace)
                    }
                    return {
                        mount: function t() {
                            n = i.Transition, o([tc, ty, tv, tm], C)
                        },
                        move: function t(e, i, s, r) {
                            var o, d;
                            e !== i && (o = e > s, d = b(x(T(), o)), o ? d >= 0 : d <= S[y("scrollWidth")] - R(E)[y("width")]) && (A(), w(x(T(), e > s), !0)), l(4), a(th, i, s, e), n.start(i, function () {
                                l(3), a(tp, i, s, e), r && r()
                            })
                        },
                        jump: k,
                        translate: w,
                        shift: x,
                        cancel: A,
                        toIndex: M,
                        toPosition: P,
                        getPosition: T,
                        getLimit: B,
                        exceededLimit: function t(e, i) {
                            i = h(i) ? T() : i;
                            var s = !0 !== e && b(i) < b(B(!1)),
                                n = !1 !== e && b(i) > b(B(!0));
                            return s || n
                        },
                        reposition: C
                    }
                },
                Controller: function t(e, i, n) {
                    var r, o, a, l, d = tk(e),
                        c = d.on,
                        p = d.emit,
                        f = i.Move,
                        m = f.getPosition,
                        v = f.getLimit,
                        g = f.toPosition,
                        y = i.Slides,
                        b = y.isEnough,
                        $ = y.getLength,
                        S = n.omitEnd,
                        E = e.is(ep),
                        L = e.is(eh),
                        _ = s(M, !1),
                        C = s(M, !0),
                        k = n.start || 0,
                        w = k;
                    function x() {
                        o = $(!0), a = n.perMove, l = n.perPage, r = B();
                        var t = tn(k, 0, S ? r : o - 1);
                        t !== k && (k = t, f.reposition())
                    }
                    function A() {
                        r !== B() && p("ei")
                    }
                    function M(t, e) {
                        var i, s, n = a || (O() ? 1 : l),
                            o = P(k + n * (t ? -1 : 1), k, !(a || O()));
                        if (-1 === o && L) {
                            if (i = m(), !(1 > te(i - (s = v(!t))))) return t ? 0 : r
                        }
                        return e ? o : T(o)
                    }
                    function P(t, i, s) {
                        if (b() || O()) {
                            var d = function t(i) {
                                if (L && "move" === n.trimSpace && i !== k)
                                    for (var s = m(); s === g(i, !0) && ts(i, 0, e.length - 1, !n.rewind);) i < k ? --i : ++i;
                                return i
                            }(t);
                            d !== t && (i = t, t = d, s = !1), t < 0 || t > r ? t = !a && (ts(0, t, i, !0) || ts(r, i, t, !0)) ? q(D(t)) : E ? s ? t < 0 ? -(o % l || l) : o : t : n.rewind ? t < 0 ? r : 0 : -1 : s && t !== i && (t = q(D(i) + (t < i ? -1 : 1)))
                        } else t = -1;
                        return t
                    }
                    function T(t) {
                        return E ? (t + o) % o || 0 : t
                    }
                    function B() {
                        for (var t = o - (O() || E && a ? 1 : l); S && t-- > 0;)
                            if (g(o - 1, !0) !== g(t, !0)) {
                                t++;
                                break
                            } return tn(t, 0, o - 1)
                    }
                    function q(t) {
                        return tn(O() ? t : l * t, 0, r)
                    }
                    function D(t) {
                        return O() ? J(t, r) : Z((t >= r ? o - 1 : t) / l)
                    }
                    function I(t) {
                        t !== k && (w = k, k = t)
                    }
                    function O() {
                        return !h(n.focus) || n.isNavigation
                    }
                    function H() {
                        return e.state.is([4, 5]) && !!n.waitForTransition
                    }
                    return {
                        mount: function t() {
                            x(), c([tv, tm, "ei"], x), c(ty, A)
                        },
                        go: function t(e, i, s) {
                            if (!H()) {
                                var n = function t(e) {
                                        var i = k;
                                        if (u(e)) {
                                            var s = e.match(/([+\-<>])(\d+)?/) || [],
                                                n = s[1],
                                                o = s[2];
                                            "+" === n || "-" === n ? i = P(k + +("" + n + (+o || 1)), k) : ">" === n ? i = o ? q(+o) : _(!0) : "<" === n && (i = C(!0))
                                        } else i = E ? e : tn(e, 0, r);
                                        return i
                                    }(e),
                                    o = T(n);
                                o > -1 && (i || o !== k) && (I(o), f.move(n, o, w, s))
                            }
                        },
                        scroll: function t(e, s, n, o) {
                            i.Scroll.scroll(e, s, n, function () {
                                var t = T(f.toIndex(m()));
                                I(S ? J(t, r) : t), o && o()
                            })
                        },
                        getNext: _,
                        getPrev: C,
                        getAdjacent: M,
                        getEnd: B,
                        setIndex: I,
                        getIndex: function t(e) {
                            return e ? w : k
                        },
                        toIndex: q,
                        toPage: D,
                        toDest: function t(e) {
                            var i = f.toIndex(e);
                            return L ? tn(i, 0, r) : i
                        },
                        hasFocus: O,
                        isBusy: H
                    }
                },
                Arrows: function t(e, i, n) {
                    var r, o, a = tk(e),
                        l = a.on,
                        d = a.bind,
                        c = a.emit,
                        u = n.classes,
                        h = n.i18n,
                        p = i.Elements,
                        f = i.Controller,
                        m = p.arrows,
                        v = p.track,
                        g = m,
                        y = p.prev,
                        b = p.next,
                        L = {};
                    function _() {
                        var t;
                        (t = n.arrows) && !(y && b) && (g = m || B("div", u.arrows), y = A(!0), b = A(!1), r = !0, S(g, [y, b]), m || E(g, v)), y && b && (x(L, {
                            prev: y,
                            next: b
                        }), D(g, t ? "" : "none"), $(g, o = t6 + "--" + n.direction), t && (l([tc, tp, tm, t$, "ei"], M), d(b, "click", s(w, ">")), d(y, "click", s(w, "<")), M(), T([y, b], tI, v.id), c("arrows:mounted", y, b))), l(tv, C)
                    }
                    function C() {
                        k(), _()
                    }
                    function k() {
                        a.destroy(), X(g, o), r ? (N(m ? [y, b] : g), y = b = null) : P([y, b], tV)
                    }
                    function w(t) {
                        f.go(t, !0)
                    }
                    function A(t) {
                        return W('<button class="' + u.arrow + " " + (t ? u.prev : u.next) + '" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' + (n.arrowPath || "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") + '" />')
                    }
                    function M() {
                        if (y && b) {
                            var t = e.index,
                                i = f.getPrev(),
                                s = f.getNext(),
                                n = i > -1 && t < i ? h.last : h.prev,
                                r = s > -1 && t > s ? h.first : h.next;
                            y.disabled = i < 0, b.disabled = s < 0, T(y, tR, n), T(b, tR, r), c("arrows:updated", y, b, i, s)
                        }
                    }
                    return {
                        arrows: L,
                        mount: _,
                        destroy: k,
                        update: M
                    }
                },
                Autoplay: function t(e, i, s) {
                    var n, r, o = tk(e),
                        a = o.on,
                        l = o.bind,
                        d = o.emit,
                        c = tw(s.interval, e.go.bind(e, ">"), function t(e) {
                            var i = h.bar;
                            i && q(i, "width", 100 * e + "%"), d("autoplay:playing", e)
                        }),
                        u = c.isPaused,
                        h = i.Elements,
                        p = i.Elements,
                        f = p.root,
                        m = p.toggle,
                        v = s.autoplay,
                        g = "pause" === v;
                    function y() {
                        u() && i.Slides.isEnough() && (c.start(!s.resetProgress), r = n = g = !1, E(), d(tL))
                    }
                    function $(t) {
                        void 0 === t && (t = !0), g = !!t, E(), u() || (c.pause(), d(t_))
                    }
                    function S() {
                        g || (n || r ? $(!1) : y())
                    }
                    function E() {
                        m && (b(m, ee, !g), T(m, tR, s.i18n[g ? "play" : "pause"]))
                    }
                    function L(t) {
                        var e = i.Slides.getAt(t);
                        c.set(e && +O(e.slide, em) || s.interval)
                    }
                    return {
                        mount: function t() {
                            v && (s.pauseOnHover && l(f, "mouseenter mouseleave", function (t) {
                                n = "mouseenter" === t.type, S()
                            }), s.pauseOnFocus && l(f, "focusin focusout", function (t) {
                                r = "focusin" === t.type, S()
                            }), m && l(m, "click", function () {
                                g ? y() : $(!0)
                            }), a([th, tb, tm], c.rewind), a(th, L), m && T(m, tI, h.track.id), g || y(), E())
                        },
                        destroy: c.cancel,
                        play: y,
                        pause: $,
                        isPaused: u
                    }
                },
                Cover: function t(e, i, n) {
                    var r = tk(e).on;
                    function o(t) {
                        i.Slides.forEach(function (e) {
                            var i = C(e.container || e.slide, "img");
                            i && i.src && a(t, i, e)
                        })
                    }
                    function a(t, e, i) {
                        i.style("background", t ? 'center/cover no-repeat url("' + e.src + '")' : "", !0), D(e, t ? "none" : "")
                    }
                    return {
                        mount: function t() {
                            n.cover && (r(tC, s(a, !0)), r([tc, tv, tm], s(o, !0)))
                        },
                        destroy: s(o, !1)
                    }
                },
                Scroll: function t(e, i, n) {
                    var r, o, a = tk(e),
                        l = a.on,
                        d = a.emit,
                        c = e.state.set,
                        u = i.Move,
                        h = u.getPosition,
                        p = u.getLimit,
                        f = u.exceededLimit,
                        m = u.translate,
                        v = e.is(eh),
                        g = 1;
                    function y(t, e, n, a, l) {
                        var p = h();
                        if (S(), n && (!v || !f())) {
                            var m = i.Layout.sliderSize(),
                                y = tr(t) * m * Z(te(t) / m) || 0;
                            t = u.toPosition(i.Controller.toDest(t % m)) + y
                        }
                        var E, L, _ = (E = p, L = t, 1 > te(E - L));
                        g = 1, e = _ ? 0 : e || Q(te(t - p) / 1.5, 800), o = a, r = tw(e, b, s($, p, t, l), 1), c(5), d(tb), r.start()
                    }
                    function b() {
                        c(3), o && o(), d(t$)
                    }
                    function $(t, e, i, s) {
                        var r, a, l = h(),
                            d = (t + (e - t) * (r = s, a = n.easingFunc, a ? a(r) : 1 - Math.pow(1 - r, 4)) - l) * g;
                        m(l + d), v && !i && f() && (g *= .6, 10 > te(d) && y(p(f(!0)), 600, !1, o, !0))
                    }
                    function S() {
                        r && r.cancel()
                    }
                    function E() {
                        r && !r.isPaused() && (S(), b())
                    }
                    return {
                        mount: function t() {
                            l(th, S), l([tv, tm], E)
                        },
                        destroy: S,
                        scroll: y,
                        cancel: E
                    }
                },
                Drag: function t(e, i, s) {
                    var n, o, a, d, c, u, h, p, f = tk(e),
                        m = f.on,
                        v = f.emit,
                        g = f.bind,
                        y = f.unbind,
                        b = e.state,
                        $ = i.Move,
                        S = i.Scroll,
                        E = i.Controller,
                        _ = i.Elements.track,
                        C = i.Media.reduce,
                        k = i.Direction,
                        w = k.resolve,
                        x = k.orient,
                        A = $.getPosition,
                        M = $.exceededLimit,
                        P = !1;
                    function T() {
                        var t, e = s.drag;
                        h = t = !e, d = "free" === e
                    }
                    function B(t) {
                        if (u = !1, !h) {
                            var e, i, n = z(t);
                            e = t.target, i = s.noDrag, L(e, "." + tJ + ", ." + tY) || i && L(e, i) || !n && t.button || (E.isBusy() ? F(t, !0) : (p = n ? _ : window, c = b.is([4, 5]), a = null, g(p, ec, q, ev), g(p, eu, D, ev), $.cancel(), S.cancel(), O(t)))
                        }
                    }
                    function q(t) {
                        if (b.is(6) || (b.set(6), v("drag")), t.cancelable) {
                            if (c) {
                                $.translate(n + (p = H(t), p / (P && e.is(eh) ? 5 : 1)));
                                var i, r, o, a, d, h, p, f = R(t) > 200,
                                    m = P !== (P = M());
                                (f || m) && O(t), u = !0, v("dragging"), F(t)
                            } else {
                                i = t, te(H(i)) > te(H(i, !0)) && (c = (r = t, o = s.dragMinThreshold, a = l(o), d = a && o.mouse || 0, h = (a ? o.touch : +o) || 10, te(H(r)) > (z(r) ? h : d)), F(t))
                            }
                        }
                    }
                    function D(t) {
                        var n, r, o, a, l;
                        b.is(6) && (b.set(3), v("dragged")), c && (a = (r = o = function t(i) {
                            if (e.is(ep) || !P) {
                                var s = R(i);
                                if (s && s < 200) return H(i) / s
                            }
                            return 0
                        }(n = t), A() + tr(r) * J(te(r) * (s.flickPower || 600), d ? 1 / 0 : i.Layout.listSize() * (s.flickMaxPages || 1))), l = s.rewind && s.rewindByDrag, C(!1), d ? E.scroll(a, 0, s.snap) : e.is(ef) ? E.go(0 > x(tr(o)) ? l ? "<" : "-" : l ? ">" : "+") : e.is(eh) && P && l ? E.go(M(!0) ? ">" : "<") : E.go(E.toDest(a), !0), C(!0), F(t)), y(p, ec, q), y(p, eu, D), c = !1
                    }
                    function I(t) {
                        !h && u && F(t, !0)
                    }
                    function O(t) {
                        a = o, o = t, n = A()
                    }
                    function H(t, e) {
                        return W(t, e) - W(N(t), e)
                    }
                    function R(t) {
                        return U(t) - U(N(t))
                    }
                    function N(t) {
                        return o === t && a || o
                    }
                    function W(t, e) {
                        return (z(t) ? t.changedTouches[0] : t)["page" + w(e ? "Y" : "X")]
                    }
                    function z(t) {
                        return "undefined" != typeof TouchEvent && t instanceof TouchEvent
                    }
                    function V() {
                        return c
                    }
                    function X(t) {
                        h = t
                    }
                    return {
                        mount: function t() {
                            g(_, ec, r, ev), g(_, eu, r, ev), g(_, ed, B, ev), g(_, "click", I, {
                                capture: !0
                            }), g(_, "dragstart", F), m([tc, tv], T)
                        },
                        disable: X,
                        isDragging: V
                    }
                },
                Keyboard: function t(e, i, s) {
                    var r, o, a = tk(e),
                        l = a.on,
                        d = a.bind,
                        c = a.unbind,
                        u = e.root,
                        h = i.Direction.resolve;
                    function p() {
                        var t = s.keyboard;
                        t && d(r = "global" === t ? window : u, eb, g)
                    }
                    function f() {
                        c(r, eb)
                    }
                    function m(t) {
                        o = t
                    }
                    function v() {
                        var t = o;
                        o = !0, n(function () {
                            o = t
                        })
                    }
                    function g(t) {
                        if (!o) {
                            var i = ey(t);
                            i === h(tA) ? e.go("<") : i === h(t8) && e.go(">")
                        }
                    }
                    return {
                        mount: function t() {
                            p(), l(tv, f), l(tv, p), l(th, v)
                        },
                        destroy: f,
                        disable: m
                    }
                },
                LazyLoad: function t(i, n, r) {
                    var o = tk(i),
                        a = o.on,
                        l = o.off,
                        d = o.bind,
                        c = o.emit,
                        u = "sequential" === r.lazyLoad,
                        h = [tp, t$],
                        p = [];
                    function f() {
                        e(p), n.Slides.forEach(function (t) {
                            V(t.slide, eE).forEach(function (e) {
                                var i = O(e, e$),
                                    s = O(e, eS);
                                if (i !== e.src || s !== e.srcset) {
                                    var n = r.classes.spinner,
                                        o = e.parentElement,
                                        a = C(o, "." + n) || B("span", n, o);
                                    p.push([e, t, a]), e.src || D(e, "none")
                                }
                            })
                        }), u ? y() : (l(h), a(h, m), m())
                    }
                    function m() {
                        (p = p.filter(function (t) {
                            var e = r.perPage * ((r.preloadPages || 1) + 1) - 1;
                            return !t[1].isWithin(i.index, e) || v(t)
                        })).length || l(h)
                    }
                    function v(t) {
                        var e = t[0];
                        $(t[1].slide, er), d(e, "load error", s(g, t)), T(e, "src", O(e, e$)), T(e, "srcset", O(e, eS)), P(e, e$), P(e, eS)
                    }
                    function g(t, e) {
                        var i = t[0],
                            s = t[1];
                        X(s.slide, er), "error" !== e.type && (N(t[2]), D(i, ""), c(tC, i, s), c(tg)), u && y()
                    }
                    function y() {
                        p.length && v(p.shift())
                    }
                    return {
                        mount: function t() {
                            r.lazyLoad && (f(), a(tm, f))
                        },
                        destroy: s(e, p),
                        check: m
                    }
                },
                Pagination: function t(n, r, o) {
                    var a, l, d = tk(n),
                        c = d.on,
                        u = d.emit,
                        h = d.bind,
                        p = r.Slides,
                        f = r.Elements,
                        m = r.Controller,
                        v = m.hasFocus,
                        g = m.getIndex,
                        y = m.go,
                        b = r.Direction.resolve,
                        S = f.pagination,
                        E = [];
                    function L() {
                        _(), c([tv, tm, "ei"], L);
                        var t = o.pagination;
                        S && D(S, t ? "" : "none"), t && (c([th, tb, t$], A), function t() {
                            var e = n.length,
                                i = o.classes,
                                r = o.i18n,
                                d = o.perPage,
                                c = v() ? m.getEnd() + 1 : tt(e / d);
                            a = S || B("ul", i.pagination, f.track.parentElement), $(a, l = t7 + "--" + w()), T(a, tB, "tablist"), T(a, tR, r.select), T(a, tF, "ttb" === w() ? "vertical" : "");
                            for (var u = 0; u < c; u++) {
                                var g = B("li", null, a),
                                    y = B("button", {
                                        class: i.page,
                                        type: "button"
                                    }, g),
                                    b = p.getIn(u).map(function (t) {
                                        return t.slide.id
                                    }),
                                    L = !v() && d > 1 ? r.pageX : r.slideX;
                                h(y, "click", s(C, u)), o.paginationKeyboard && h(y, "keydown", s(k, u)), T(g, tB, "presentation"), T(y, tB, "tab"), T(y, tI, b.join(" ")), T(y, tR, to(L, u + 1)), T(y, tq, -1), E.push({
                                    li: g,
                                    button: y,
                                    page: u
                                })
                            }
                        }(), A(), u("pagination:mounted", {
                            list: a,
                            items: E
                        }, x(n.index)))
                    }
                    function _() {
                        a && (N(S ? i(a.children) : a), X(a, l), e(E), a = null), d.destroy()
                    }
                    function C(t) {
                        y(">" + t, !0)
                    }
                    function k(t, e) {
                        var i = E.length,
                            s = ey(e),
                            n = w(),
                            r = -1;
                        s === b(t8, !1, n) ? r = ++t % i : s === b(tA, !1, n) ? r = (--t + i) % i : "Home" === s ? r = 0 : "End" === s && (r = i - 1);
                        var o = E[r];
                        o && (I(o.button), y(">" + r), F(e, !0))
                    }
                    function w() {
                        return o.paginationDirection || o.direction
                    }
                    function x(t) {
                        return E[m.toPage(t)]
                    }
                    function A() {
                        var t = x(g(!0)),
                            e = x(g());
                        if (t) {
                            var i = t.button;
                            X(i, ee), P(i, tH), T(i, tq, -1)
                        }
                        if (e) {
                            var s = e.button;
                            $(s, ee), T(s, tH, !0), T(s, tq, "")
                        }
                        u("pagination:updated", {
                            list: a,
                            items: E
                        }, t, e)
                    }
                    return {
                        items: E,
                        mount: L,
                        destroy: _,
                        getAt: x,
                        update: A
                    }
                },
                Sync: function t(i, n, r) {
                    var o = r.isNavigation,
                        a = r.slideFocus,
                        l = [];
                    function d() {
                        var t, e;
                        i.splides.forEach(function (t) {
                            t.isParent || (u(i, t.splide), u(t.splide, i))
                        }), o && (t = tk(i), e = t.on, e(tf, f), e("sk", m), e([tc, tv], p), l.push(t), t.emit(tE, i.splides))
                    }
                    function c() {
                        l.forEach(function (t) {
                            t.destroy()
                        }), e(l)
                    }
                    function u(t, e) {
                        var i = tk(t);
                        i.on(th, function (t, i, s) {
                            e.go(e.is(ep) ? s : t)
                        }), l.push(i)
                    }
                    function p() {
                        T(n.Elements.list, tF, "ttb" === r.direction ? "vertical" : "")
                    }
                    function f(t) {
                        i.go(t.index)
                    }
                    function m(t, e) {
                        g(eL, ey(e)) && (f(t), F(e))
                    }
                    return {
                        setup: s(n.Media.set, {
                            slideFocus: h(a) ? o : a
                        }, !0),
                        mount: d,
                        destroy: c,
                        remount: function t() {
                            c(), d()
                        }
                    }
                },
                Wheel: function t(e, i, s) {
                    var n = tk(e).bind,
                        r = 0;
                    function o(t) {
                        if (t.cancelable) {
                            var n, o = t.deltaY,
                                a = o < 0,
                                l = U(t),
                                d = s.wheelMinThreshold || 0,
                                c = s.wheelSleep || 0;
                            te(o) > d && l - r > c && (e.go(a ? "<" : ">"), r = l), n = a, (!s.releaseWheel || e.state.is(4) || -1 !== i.Controller.getAdjacent(n)) && F(t)
                        }
                    }
                    return {
                        mount: function t() {
                            s.wheel && n(i.Elements.track, "wheel", o, ev)
                        }
                    }
                },
                Live: function t(e, i, n) {
                    var r = tk(e).on,
                        o = i.Elements.track,
                        a = n.live && !n.isNavigation,
                        l = B("span", et),
                        d = tw(90, s(c, !1));
                    function c(t) {
                        T(o, t9, t), t ? (S(o, l), d.start()) : (N(l), d.cancel())
                    }
                    function u(t) {
                        a && T(o, tz, t ? "off" : "polite")
                    }
                    return {
                        mount: function t() {
                            a && (u(!i.Autoplay.isPaused()), T(o, t0, !0), l.textContent = "â€¦", r(tL, s(u, !0)), r(t_, s(u, !1)), r([tp, t$], s(c, !0)))
                        },
                        disable: u,
                        destroy: function t() {
                            P(o, [tz, t0, t9]), N(l)
                        }
                    }
                }
            }),
            eC = {
                type: "slide",
                role: "region",
                speed: 400,
                perPage: 1,
                cloneStatus: !0,
                arrows: !0,
                pagination: !0,
                paginationKeyboard: !0,
                interval: 5e3,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                resetProgress: !0,
                easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                drag: !0,
                direction: "ltr",
                trimSpace: !0,
                focusableNodes: "a, button, textarea, input, select, iframe",
                live: !0,
                classes: {
                    slide: tU,
                    clone: tG,
                    arrows: t6,
                    arrow: tY,
                    prev: tK,
                    next: t5,
                    pagination: t7,
                    page: tJ,
                    spinner: t4 + "spinner"
                },
                i18n: {
                    prev: "Previous slide",
                    next: "Next slide",
                    first: "Go to first slide",
                    last: "Go to last slide",
                    slideX: "Go to slide %s",
                    pageX: "Go to page %s",
                    play: "Start autoplay",
                    pause: "Pause autoplay",
                    carousel: "carousel",
                    slide: "slide",
                    select: "Select a slide to show",
                    slideLabel: "%s of %s"
                },
                reducedMotion: {
                    speed: 0,
                    rewindSpeed: 0,
                    autoplay: "pause"
                }
            };
        function ek(t, e, i) {
            var s = e.Slides;
            function o() {
                s.forEach(function (t) {
                    t.style("transform", "translateX(-" + 100 * t.index + "%)")
                })
            }
            return {
                mount: function e() {
                    tk(t).on([tc, tm], o)
                },
                start: function t(e, r) {
                    s.style("transition", "opacity " + i.speed + "ms " + i.easing), n(r)
                },
                cancel: r
            }
        }
        function ew(t, e, i) {
            var n, r = e.Move,
                o = e.Controller,
                a = e.Scroll,
                l = e.Elements.list,
                d = s(q, l, "transition");
            function c() {
                d(""), a.cancel()
            }
            return {
                mount: function e() {
                    tk(t).bind(l, "transitionend", function (t) {
                        t.target === l && n && (c(), n())
                    })
                },
                start: function e(s, l) {
                    var c = r.toPosition(s, !0),
                        u = r.getPosition(),
                        h = function e(s) {
                            var n = i.rewindSpeed;
                            if (t.is(eh) && n) {
                                var r = o.getIndex(!0),
                                    a = o.getEnd();
                                if (0 === r && s >= a || r >= a && 0 === s) return n
                            }
                            return i.speed
                        }(s);
                    te(c - u) >= 1 && h >= 1 ? i.useScroll ? a.scroll(c, h, !1, l) : (d("transform " + h + "ms " + i.easing), r.translate(c, !0), n = l) : (r.jump(s), l())
                },
                cancel: c
            }
        }
        var ex = function () {
            function t(e, i) {
                this.event = tk(), this.Components = {}, this.state = function t(e) {
                    var i = 1;
                    function s(t) {
                        i = t
                    }
                    return {
                        set: s,
                        is: function t(e) {
                            return g(m(e), i)
                        }
                    }
                }(1), this.splides = [], this._o = {}, this._E = {};
                var s = u(e) ? z(document, e) : e;
                K(s, s + " is invalid."), this.root = s, i = A({
                    label: O(s, tR) || "",
                    labelledby: O(s, tN) || ""
                }, eC, t.defaults, i || {});
                try {
                    A(i, JSON.parse(O(s, Y)))
                } catch (n) {
                    K(!1, "Invalid JSON")
                }
                this._o = Object.create(A({}, i))
            }
            var s = t.prototype;
            return s.mount = function t(e, i) {
                var s = this,
                    n = this.state,
                    r = this.Components;
                K(n.is([1, 7]), "Already mounted!"), n.set(1), this._C = r, this._T = i || this._T || (this.is(ef) ? ek : ew), this._E = e || this._E;
                var o = x({}, e_, this._E, {
                    Transition: this._T
                });
                return w(o, function (t, e) {
                    var i = t(s, r, s._o);
                    r[e] = i, i.setup && i.setup()
                }), w(r, function (t) {
                    t.mount && t.mount()
                }), this.emit(tc), $(this.root, "is-initialized"), n.set(3), this.emit(tu), this
            }, s.sync = function t(e) {
                return this.splides.push({
                    splide: e
                }), e.splides.push({
                    splide: this,
                    isParent: !0
                }), this.state.is(3) && (this._C.Sync.remount(), e.Components.Sync.remount()), this
            }, s.go = function t(e) {
                return this._C.Controller.go(e), this
            }, s.on = function t(e, i) {
                return this.event.on(e, i), this
            }, s.off = function t(e) {
                return this.event.off(e), this
            }, s.emit = function t(e) {
                var s;
                return (s = this.event).emit.apply(s, [e].concat(i(arguments, 1))), this
            }, s.add = function t(e, i) {
                return this._C.Slides.add(e, i), this
            }, s.remove = function t(e) {
                return this._C.Slides.remove(e), this
            }, s.is = function t(e) {
                return this._o.type === e
            }, s.refresh = function t() {
                return this.emit(tm), this
            }, s.destroy = function t(i) {
                void 0 === i && (i = !0);
                var s = this.event,
                    n = this.state;
                return n.is(1) ? tk(this).on(tu, this.destroy.bind(this, i)) : (w(this._C, function (t) {
                    t.destroy && t.destroy(i)
                }, !0), s.emit(tS), s.destroy(), i && e(this.splides), n.set(7)), this
            }, _createClass(t, [{
                key: "options",
                get: function t() {
                    return this._o
                },
                set: function t(e) {
                    this._C.Media.set(e, !0, !0)
                }
            }, {
                key: "length",
                get: function t() {
                    return this._C.Slides.getLength(!0)
                }
            }, {
                key: "index",
                get: function t() {
                    return this._C.Controller.getIndex()
                }
            }]), t
        }();
        return ex.defaults = {}, ex.STATES = {
            CREATED: 1,
            MOUNTED: 2,
            IDLE: 3,
            MOVING: 4,
            SCROLLING: 5,
            DRAGGING: 6,
            DESTROYED: 7
        }, ex
    });
class SplideComponent extends HTMLElement {
    constructor() {
        super(), this.sliderContainer = this.querySelector(".splide"), document.addEventListener("shopify:section:load", t => {
            this.initSlider()
        })
    }
    connectedCallback() {
        this.initSlider()
    }
    initSlider() {
        this.type = this.dataset.type || "slide", this.typeMobile = this.dataset.typeMobile || this.type, this.direction = this.dataset.direction || defaultDirection, this.rewind = "fade" === this.type, this.autoplay = "true" === this.dataset.autoplay, this.autoplaySpeed = this.dataset.autoplaySpeed && !isNaN(parseInt(this.dataset.autoplaySpeed)) ? 1e3 * parseInt(this.dataset.autoplaySpeed) : 5e3, this.drag = "false" !== this.dataset.drag && ("free" !== this.dataset.drag || "free"), this.focus = this.dataset.focus || 0, this.trimSpace = "false" !== this.dataset.trimSpace, this.arrows = "true" !== this.dataset.arrows, this.arrowsColor = this.dataset.arrowsColor ? ` color-${this.dataset.arrowsColor}` : "", this.pagination = "false" !== this.dataset.pagination, this.omitEnd = "false" !== this.dataset.omitEnd, this.dotsColor = this.dataset.dotsColor ? ` color-${this.dataset.dotsColor} dots-custom-color` : "", this.slidesDesktop = this.dataset.slidesDesktop && !isNaN(parseInt(this.dataset.slidesDesktop)) ? parseInt(this.dataset.slidesDesktop) : 3, this.autoWidth = "true" === this.dataset.autoWidth, this.slidesMobile = this.dataset.slidesMobile && !isNaN(parseInt(this.dataset.slidesMobile)) ? parseInt(this.dataset.slidesMobile) : 1, this.perMoveDesktop = this.dataset.perMoveDesktop && !isNaN(parseInt(this.dataset.perMoveDesktop)) ? parseInt(this.dataset.perMoveDesktop) : 1, this.perMoveMobile = this.dataset.perMoveMobile && !isNaN(parseInt(this.dataset.perMoveMobile)) ? parseInt(this.dataset.perMoveMobile) : 1, this.gapDesktop = this.dataset.gapDesktop ? parseInt(this.dataset.gapDesktop) : 30, this.gapMobile = this.dataset.gapMobile ? parseInt(this.dataset.gapMobile) : 15, this.paddingCalcDesktop = "true" === this.dataset.paddingCalcDesktop, this.rightPaddingDesktop = parseInt(this.dataset.sidePaddingDesktop) || 0, this.leftPaddingDesktop = this.dataset.paddingCalcDesktop ? 0 : this.rightPaddingDesktop, this.paddingCalcMobile = "true" === this.dataset.paddingCalcMobile, this.rightPaddingMobile = parseInt(this.dataset.sidePaddingMobile) || 0, this.leftPaddingMobile = this.paddingCalcMobile ? 0 : this.rightPaddingMobile, this.destroyDesktop = "true" === this.dataset.destroyDesktop, this.destroyMobile = "true" === this.dataset.destroyMobile, this.config = {
            type: this.type,
            direction: this.direction,
            rewind: this.rewind,
            autoplay: this.autoplay,
            interval: this.autoplaySpeed,
            drag: this.drag,
            focus: this.focus,
            trimSpace: this.trimSpace,
            arrows: this.arrows,
            pagination: this.pagination,
            omitEnd: this.omitEnd,
            perPage: this.slidesDesktop,
            perMove: this.perMoveDesktop,
            autoWidth: this.autoWidth,
            gap: this.gapDesktop,
            paddingCalc: this.paddingCalcDesktop,
            padding: {
                left: this.leftPaddingDesktop,
                right: this.rightPaddingDesktop
            },
            destroy: this.destroyDesktop,
            classes: {
                arrow: `splide__arrow${this.arrowsColor}`,
                page: `splide__pagination__page${this.dotsColor}`
            },
            easing: "cubic-bezier(0.25, 1, 0.5, 1)",
            breakpoints: {
                749: {
                    omitEnd: this.omitEnd,
                    type: this.typeMobile,
                    perPage: this.slidesMobile,
                    perMove: this.perMoveMobile,
                    gap: this.gapMobile,
                    paddingCalc: this.paddingCalcMobile,
                    padding: {
                        left: this.leftPaddingMobile,
                        right: this.rightPaddingMobile
                    },
                    destroy: this.destroyMobile
                }
            }
        };
        let t = new Splide(this.sliderContainer, this.config);
        t.on("mounted", () => {
            let e = t.index,
                i = t.Components.Elements.slides[e];
            if (i) {
                let s = i.querySelector("img");
                s ? s.complete ? (i.classList.add("is-instant-active"), this.setActiveSlideHeight(i)) : s.addEventListener("load", () => {
                    i.classList.add("is-instant-active"), this.setActiveSlideHeight(i)
                }) : (i.classList.add("is-instant-active"), this.setActiveSlideHeight(i))
            }
            let n = debounce(() => {
                let e = t.Components.Elements.slides[t.index];
                this.setActiveSlideHeight(e)
            }, 200);
            window.addEventListener("resize", n)
        }), t.on("move", e => {
            let i = t.index,
                s = t.Components.Elements.slides;
            if (s) {
                let n = s[i];
                n && (s.forEach(t => t.classList.remove("is-instant-active")), n.classList.add("is-instant-active"), this.setActiveSlideHeight(n))
            }
        }), "true" === this.dataset.pauseVideos && t.on("hidden", t => {
            let e = t.slide.querySelector("internal-video");
            if (e) {
                let i = e.dataset.actionOnInactive;
                "pause" === i ? (e.video.pause(), e.classList.remove("internal-video--playing")) : "mute" === i && (e.video.muted = !0, e.classList.add("internal-video--muted"))
            }
        }), t.mount()
    }
    setActiveSlideHeight(t) {
        if (t) {
            let e = t.offsetHeight;
            this.style.setProperty("--active-slide-height", `${e}px`)
        }
    }
}
customElements.define("splide-component", SplideComponent);
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super(), this.mainDetailsToggle = this.querySelector("details"), this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling, this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this)), this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this))
    }
    onFocusOut() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close()
        })
    }
    onToggle() {
        this.animations || (this.animations = this.content.getAnimations()), this.mainDetailsToggle.hasAttribute("open") ? this.animations.forEach(t => t.play()) : this.animations.forEach(t => t.cancel())
    }
    close() {
        this.mainDetailsToggle.removeAttribute("open"), this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1)
    }
}
customElements.define("details-disclosure", DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
    constructor() {
        super(), this.header = document.querySelector(".header-wrapper")
    }
    onToggle() {
        this.header && (this.header.preventHide = this.mainDetailsToggle.open, "" === document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") && document.documentElement.style.setProperty("--header-bottom-position-desktop", `${Math.floor(this.header.getBoundingClientRect().bottom)}px`))
    }
}
customElements.define("header-menu", HeaderMenu);
class DetailsModal extends HTMLElement {
    constructor() {
        super(), this.detailsContainer = this.querySelector("details"), this.summaryToggle = this.querySelector("summary"), this.detailsContainer.addEventListener("keyup", t => "ESCAPE" === t.code.toUpperCase() && this.close()), this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this)), this.querySelector('button[type="button"]').addEventListener("click", this.close.bind(this)), this.summaryToggle.setAttribute("role", "button")
    }
    isOpen() {
        return this.detailsContainer.hasAttribute("open")
    }
    onSummaryClick(t) {
        t.preventDefault(), t.target.closest("details").hasAttribute("open") ? this.close() : this.open(t)
    }
    onBodyClick(t) {
        (!this.contains(t.target) || t.target.classList.contains("modal-overlay")) && this.close(!1)
    }
    open(t) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), t.target.closest("details").setAttribute("open", !0), document.body.addEventListener("click", this.onBodyClickEvent), document.body.classList.add("overflow-hidden"), "function" == typeof trapFocus && trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'))
    }
    close(t = !0) {
        "function" == typeof removeTrapFocus && removeTrapFocus(t ? this.summaryToggle : null), this.detailsContainer.removeAttribute("open"), document.body.removeEventListener("click", this.onBodyClickEvent), document.body.classList.remove("overflow-hidden")
    }
}
customElements.define("details-modal", DetailsModal);
let hotspotButtons = [];
function registerHotspotButton(t) {
    hotspotButtons.push(t)
}
function unregisterHotspotButton(t) {
    let e = hotspotButtons.indexOf(t); - 1 !== e && hotspotButtons.splice(e, 1)
}
document.addEventListener("mousedown", function (t) {
    for (let e of hotspotButtons) "true" !== e.dataset.open || e.contains(t.target) || e.closeModal()
});
class HotspotButton extends HTMLElement {
    constructor() {
        super(), this.button = this.querySelector(".hotspot-btn"), this.content = this.querySelector(".hotspot__content"), this.type = this.dataset.type, this.openEvent = this.dataset.openEvent, this.header = document.querySelector(".section-header"), this.stickyHeader = document.querySelector("sticky-header"), this.mobileOverlay = this.querySelector(".hotspot-overlay"), this.button.addEventListener("click", this.toggleModal.bind(this)), "hover" === this.openEvent && window.matchMedia("(hover: hover)").matches && window.matchMedia("(pointer: fine)").matches && (this.button.addEventListener("mouseover", this.openModal.bind(this)), this.button.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this)), this.content.addEventListener("mouseover", this.stopCheckingMouseLeave.bind(this)), this.content.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this))), this.mobileOverlay && this.mobileOverlay.addEventListener("click", this.closeModal.bind(this))
    }
    startCheckingMouseLeave() {
        this.checkingMouseLeave = !0, setTimeout(() => {
            this.checkingMouseLeave && this.closeModal()
        }, 200)
    }
    stopCheckingMouseLeave() {
        this.checkingMouseLeave = !1
    }
    toggleModal() {
        "true" != this.dataset.open && this.openModal()
    }
    openModal() {
        let t = this.header.clientHeight;
        (this.header.classList.contains("shopify-section-header-hidden") || !this.stickyHeader) && (t = 0);
        this.content.getBoundingClientRect().top - t < 0 && (this.dataset.direction = "bottom"), this.dataset.open = "true"
    }
    closeModal() {
        this.dataset.open = "false", setTimeout(() => {
            this.dataset.direction = ""
        }, 100)
    }
    connectedCallback() {
        registerHotspotButton(this)
    }
    disconnectedCallback() {
        unregisterHotspotButton(this)
    }
}
customElements.define("hotspot-button", HotspotButton);
class ParallaxHero extends HTMLElement {
    constructor() {
        super(), this.overlays = this.querySelectorAll(".parallax-hero__layer"), this.animateOnEnter = "bottom" === this.dataset.animationStart, this.handleScroll(), window.addEventListener("scroll", () => requestAnimationFrame(this.handleScroll.bind(this)))
    }
    handleScroll(t) {
        var {
            top: e,
            left: i,
            height: s
        } = this.getBoundingClientRect();
        let n = window.innerHeight,
            r;
        if (this.animateOnEnter) {
            if (e > n || e + s < 0) return;
            r = Math.min((n - e) / (n + s), 1)
        } else {
            if (e > n || e + s < 0) return;
            let o = e >= 0 ? 0 : -e;
            if (o > s) return;
            r = Math.min(o / s, 1)
        }
        this.overlays.forEach(t => {
            let i = e * (parseInt(t.dataset.scrollY) / 100),
                s = parseInt(t.dataset.scrollX) * r,
                n = 100 + (parseInt(t.dataset.zoom) - 100) * r,
                o = 3.6 * parseInt(t.dataset.rotation) * r;
            t.style.transform = `translateY(${i}px) translateX(${s}%) scale(${n/100}) rotate(${o}deg)`
        })
    }
}
customElements.define("parallax-hero", ParallaxHero);
class ContentTabs extends HTMLElement {
    constructor() {
        super(), this.activeButtonClass = "true" == this.dataset.productTabs ? "active" : "content-tab-button--active", this.buttons = this.querySelectorAll(".content-tab-button-js"), this.tabs = this.querySelectorAll(".content-tab"), this.tabsContainer = this.querySelector(".content-tabs__tabs-js"), this.activeButton = this.querySelector(`.${this.activeButtonClass}`), this.activeTab = this.querySelector(".content-tab--active"), this.isMovingAnimation = "moving" === this.dataset.animation, this.isMovingAnimation && (this.activeBg = this.querySelector(".content-tab-buttom__active-bg"), this.handleActiveBg(), this.activeBg.style.transitionDuration = "0.4s"), this.setHeight(), this.buttons.forEach(t => {
            t.addEventListener("click", this.handleClick.bind(this))
        }), window.addEventListener("resize", () => {
            this.setHeight(), this.isMovingAnimation && this.handleActiveBg()
        })
    }
    handleClick(t) {
        this.activeButton = t.currentTarget, this.buttons.forEach(t => {
            t.classList.remove(this.activeButtonClass)
        }), this.activeButton.classList.add(this.activeButtonClass), this.tabs.forEach(t => {
            t.classList.remove("content-tab--active"), t.dataset.index === this.activeButton.dataset.index && (this.activeTab = t)
        }), this.activeTab.classList.add("content-tab--active"), this.setHeight(), this.isMovingAnimation && this.handleActiveBg()
    }
    setHeight() {
        this.activeTab && (this.tabsContainer.style.height = this.activeTab.clientHeight + "px")
    }
    handleActiveBg() {
        this.activeBg.style.width = this.activeButton.getBoundingClientRect().width + "px", this.activeBg.style.height = this.activeButton.getBoundingClientRect().height + "px", this.activeBg.style.top = this.activeButton.offsetTop + "px", this.activeBg.style.left = this.activeButton.offsetLeft + "px"
    }
}
customElements.define("content-tabs", ContentTabs);
class InstaStories extends HTMLElement {
    constructor() {
        super(), this.openButtons = this.querySelectorAll(".insta-story-open-btn"), this.openButtonsOverflowContainer = this.querySelector(".insta-stories__open-buttons-container"), this.openButtonsContainer = this.querySelector(".insta-stories__open-buttons"), this.openBtnsPrev = this.querySelector(".insta-stories__open-btns-prev"), this.openBtnsNext = this.querySelector(".insta-stories__open-btns-next"), this.closeButtons = this.querySelectorAll(".insta-stories__close-button"), this.modal = this.querySelector(".insta-stories__modal"), this.modalOpen = !1, this.slider = this.querySelector(".insta-stories__slider"), this.stories = this.querySelectorAll(".insta-story"), this.prevBtns = this.querySelectorAll(".insta-story__prev"), this.nextBtns = this.querySelectorAll(".insta-story__next"), this.slideBtns = this.querySelectorAll(".insta-story__slide-btn"), this.activeIndex = 0, this.activeStory = this.stories[this.activeIndex], this.lastIndex = parseInt(this.dataset.lastIndex), this.pauseResumeBtns = this.querySelectorAll(".insta-story__pause-resume-btn"), this.isPaused = !1, this.volumeBtns = this.querySelectorAll(".insta-story__volume-btn"), this.isMuted = !0, this.initStories(), this.initButtonsSlider(), this.openButtons.forEach(t => {
            t.addEventListener("click", this.openModal.bind(this))
        }), this.closeButtons.forEach(t => {
            t.addEventListener("click", this.closeModal.bind(this))
        }), this.prevBtns.forEach(t => {
            t.addEventListener("click", this.storyPrevBtnClick.bind(this))
        }), this.nextBtns.forEach(t => {
            t.addEventListener("click", this.storyNextBtnClick.bind(this))
        }), this.slideBtns.forEach(t => {
            t.addEventListener("click", this.slideBtnClick.bind(this))
        }), this.pauseResumeBtns.forEach(t => {
            t.addEventListener("click", this.togglePauseResume.bind(this))
        }), this.volumeBtns.forEach(t => {
            t.addEventListener("click", this.toggleIsMuted.bind(this))
        }), this.slider.addEventListener("touchstart", this.touchStartHandler.bind(this)), this.slider.addEventListener("touchend", this.touchEndHandler.bind(this)), document.addEventListener("keydown", t => {
            if (this.modalOpen) switch (t.key) {
            case "Escape":
                this.closeModal();
                break;
            case "ArrowLeft":
                this.storyPrevBtnClick();
                break;
            case "ArrowRight":
                this.storyNextBtnClick()
            }
        }), Shopify.designMode && (document.addEventListener("shopify:section:load", () => {
            this.initStories(), this.initButtonsSlider()
        }), document.addEventListener("shopify:section:reorder", () => {
            this.initStories(), this.initButtonsSlider()
        }))
    }
    autoplay() {
        let t = this.activeStory,
            e = parseInt(t.dataset.activeMediaIndex),
            i = t.querySelectorAll(".insta-story__media")[e],
            s = 1e3 * parseInt(i.getAttribute("data-duration"));
        this.updateProgressBars(e), this.autoplayStartTime = Date.now(), this.autoplayTimeout = setTimeout(() => {
            this.storyNextBtnClick()
        }, s)
    }
    storyPrevBtnClick() {
        let t = this.activeStory;
        "0" === t.dataset.activeMediaIndex ? this.changeActiveStory(this.activeIndex - 1) : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) - 1)
    }
    storyNextBtnClick() {
        let t = this.activeStory;
        t.dataset.activeMediaIndex === t.dataset.lastMediaIndex ? this.changeActiveStory(this.activeIndex + 1) : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) + 1)
    }
    slideBtnClick(t) {
        let e = parseInt(t.currentTarget.dataset.index);
        this.changeActiveStory(e)
    }
    changeActiveStory(t) {
        if (clearTimeout(this.autoplayTimeout), t > this.lastIndex || t < 0) return;
        let e = this.stories[this.activeIndex];
        e.classList.remove("internal-video--loading");
        let i = parseInt(e.dataset.activeMediaIndex);
        if ("true" === e.dataset.played || i > 0) {
            let s = e.querySelectorAll(".insta-story__progress-item")[i];
            s && (s.classList.remove("insta-story__progress-item--active"), t > this.activeIndex && s.classList.add("insta-story__progress-item--completed"))
        }
        let n = e.querySelectorAll(".insta-story__media")[i];
        if (n && "video" === n.getAttribute("data-type")) {
            let r = n.querySelector("video");
            r && (r.pause(), (!this.isPaused || this.bufferPaused) && (r.currentTime = 0))
        }
        this.activeIndex = t, this.activeStory = this.stories[this.activeIndex], this.stories.forEach(t => {
            t.classList.remove("insta-story--active")
        }), this.activeStory.classList.add("insta-story--active"), this.activeStory.classList.remove("internal-video--loading"), this.activeStory.dataset.played = "true", this.slider.style.transform = `translateX(calc(var(--story-width) * ${this.activeIndex*(isRtl?1:-1)}))`;
        let o = parseInt(this.activeStory.dataset.activeMediaIndex, 10);
        this.changeActiveMedia(o), this.updateProgressBars(o)
    }
    changeActiveMedia(t) {
        if (this.bufferPaused && this.isPaused && this.resumeStory(), clearTimeout(this.autoplayTimeout), t < 0) return;
        let e = this.activeStory,
            i = parseInt(e.dataset.lastMediaIndex);
        if (t > i) return;
        this.currentVideoEl && (this.currentVideoEl.removeEventListener("waiting", this._onBuffer), this.currentVideoEl.removeEventListener("playing", this._onResume), this.currentVideoEl = null), e.dataset.activeMediaIndex = t;
        let s = e.querySelectorAll(".insta-story__media");
        for (let n = 0; n < s.length; n++) {
            let r = s[n],
                o = r.querySelector("video");
            n === t ? (r.style.display = "block", "video" === r.getAttribute("data-type") && o && (this.isPaused || o.play(), this._onBuffer = () => {
                this.isPaused || this.pauseStory(!0), this.bufferPaused = !0, e.classList.add("internal-video--loading")
            }, this._onResume = () => {
                this.isPaused && this.resumeStory(), this.bufferPaused = !1, e.classList.remove("internal-video--loading")
            }, o.addEventListener("waiting", this._onBuffer), o.addEventListener("playing", this._onResume), this.currentVideoEl = o), e.querySelector(".insta-story__time-posted").innerHTML = r.dataset.timePosted) : (r.style.display = "", "video" === r.getAttribute("data-type") && o && (o.pause(), (!this.isPaused || this.bufferPaused) && (o.currentTime = 0)))
        }
        this.updateProgressBars(t), this.isPaused || this.autoplay();
        let a = e.querySelectorAll(".insta-story__prev"),
            l = e.querySelectorAll(".insta-story__next");
        a.forEach(e => {
            e.toggleAttribute("disabled", 0 === this.activeIndex && 0 === t)
        }), l.forEach(e => {
            e.toggleAttribute("disabled", this.activeIndex === this.lastIndex && t === i)
        })
    }
    updateProgressBars(t) {
        let e = this.activeStory,
            i = e.querySelectorAll(".insta-story__progress-item");
        i.forEach((e, i) => {
            e.classList.remove("insta-story__progress-item--completed", "insta-story__progress-item--active"), i < t ? e.classList.add("insta-story__progress-item--completed") : i === t && e.classList.add("insta-story__progress-item--active")
        })
    }
    openModal(t) {
        window.scrollBy(0, -1), this.modal.dataset.open = "true", this.modalOpen = !0, document.body.classList.add("overflow-hidden"), this.changeActiveStory(parseInt(t.currentTarget.dataset.index))
    }
    closeModal(t) {
        this.querySelectorAll("video").forEach(t => {
            t.pause()
        }), this.modal.dataset.open = "false", this.modalOpen = !1, document.body.classList.remove("overflow-hidden"), clearTimeout(this.autoplayTimeout)
    }
    initButtonsSlider() {
        if (this.openButtonsOverflowContainer.clientWidth > this.openButtonsContainer.clientWidth) return;
        let t = () => "ontouchstart" in window || navigator.maxTouchPoints,
            e, i = 0,
            s = 0,
            n = t => {
                this.openButtonsContainer.style.transform = `translateX(${t}px)`, i = t
            };
        this.openButtonsOverflowContainer.addEventListener("touchstart", t => {
            this.isDragging = !0, e = t.touches[0].clientX - s
        }), this.openButtonsOverflowContainer.addEventListener("touchmove", t => {
            if (!this.isDragging) return;
            let i = t.touches[0].clientX,
                s = i - e;
            s < 0 && Math.abs(s) <= this.openButtonsContainer.offsetWidth - this.openButtonsOverflowContainer.offsetWidth && n(s)
        }), this.openButtonsOverflowContainer.addEventListener("touchend", () => {
            this.isDragging = !1, s = i
        });
        let r = parseFloat(getComputedStyle(this.openButtons[0]).width),
            o = parseFloat(getComputedStyle(this.openButtonsContainer).columnGap),
            a = () => {
                let t = Math.floor(this.openButtonsOverflowContainer.clientWidth / (r + o));
                return (t - 1) * (r + o)
            },
            l = isRtl ? -1 : 1,
            d = () => {
                let t = this.openButtonsOverflowContainer.scrollLeft * l;
                this.openBtnsPrev.style.display = t <= 0 ? "none" : "grid", this.openBtnsNext.style.display = t > this.openButtonsOverflowContainer.scrollWidth - this.openButtonsContainer.clientWidth ? "none" : "grid"
            };
        this.openBtnsPrev.addEventListener("click", () => {
            this.openButtonsOverflowContainer.scrollBy({
                left: -a() * l,
                behavior: "smooth"
            }), setTimeout(d, 300)
        }), this.openBtnsNext.addEventListener("click", () => {
            this.openButtonsOverflowContainer.scrollBy({
                left: a() * l,
                behavior: "smooth"
            }), setTimeout(d, 300)
        }), d(), t() && (this.openBtnsPrev.style.display = "none", this.openBtnsNext.style.display = "none"), window.addEventListener("resize", debounce(() => {
            this.openButtonsOverflowContainer.clientWidth <= this.openButtonsContainer.clientWidth ? t() ? (this.openBtnsPrev.style.display = "none", this.openBtnsNext.style.display = "none") : d() : (this.openBtnsPrev.style.display = "none", this.openBtnsNext.style.display = "none")
        }, 250))
    }
    initStories() {
        this.stories.forEach(t => {
            let e = t.querySelectorAll(".insta-story__media");
            t.dataset.lastMediaIndex = e.length - 1, t.dataset.played = "false";
            let i = t.querySelector(".insta-story__progress");
            for (let s = 0; s < e.length; s++) {
                let n = e[s].getAttribute("data-duration"),
                    r = document.createElement("span");
                r.className = "insta-story__progress-item", r.style.setProperty("--duration", `${n}s`);
                let o = document.createElement("span");
                o.className = "insta-story__progress-bar", r.appendChild(o), i.appendChild(r)
            }
            let a = parseInt(t.dataset.activeMediaIndex);
            e[a] && (e[a].style.display = "block")
        })
    }
    togglePauseResume(t) {
        let e = "true" === t.currentTarget.getAttribute("data-paused");
        e ? this.resumeStory() : this.pauseStory(), this.pauseResumeBtns.forEach(t => {
            t.setAttribute("data-paused", e ? "false" : "true")
        })
    }
    pauseStory(t = !1) {
        this.isPaused = !0;
        let e = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)],
            i = 1e3 * parseInt(e.getAttribute("data-duration"));
        if (this.remainingTime = i - (Date.now() - this.autoplayStartTime), clearTimeout(this.autoplayTimeout), "video" === e.getAttribute("data-type") && !t) {
            let s = e.querySelector("video");
            s && s.pause()
        }
        let n = this.querySelectorAll(".insta-story__progress-bar");
        n.forEach(t => {
            t.style.animationPlayState = "paused"
        })
    }
    resumeStory() {
        this.isPaused = !1;
        let t = this.querySelectorAll(".insta-story__progress-bar");
        t.forEach(t => {
            t.style.animationPlayState = "running"
        });
        let e = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)];
        if ("video" === e.getAttribute("data-type")) {
            let i = e.querySelector("video");
            i && i.play()
        }
        this.autoplayStartTime = Date.now(), this.autoplayTimeout = setTimeout(() => {
            this.storyNextBtnClick()
        }, this.remainingTime)
    }
    toggleIsMuted(t) {
        t.currentTarget, this.isMuted = !this.isMuted;
        let e = this.querySelectorAll("video");
        e.forEach(t => {
            t.muted = this.isMuted
        }), this.volumeBtns.forEach(t => {
            this.isMuted ? t.setAttribute("data-muted", "true") : t.setAttribute("data-muted", "false")
        })
    }
    touchStartHandler(t) {
        this.touchStartX = t.touches[0].clientX
    }
    touchEndHandler(t) {
        let e = t.changedTouches[0].clientX,
            i = e - this.touchStartX;
        if (50 > Math.abs(i)) return;
        let s = isRtl ? -1 : 1;
        i < 0 ? this.activeIndex < this.lastIndex && this.changeActiveStory(this.activeIndex + s) : this.activeIndex > 0 && this.changeActiveStory(this.activeIndex - s)
    }
}
customElements.define("insta-stories", InstaStories);
class TncCheckbox extends HTMLElement {
    constructor() {
        super(), this.checked = !1;
        let t = this.dataset.target || "#CartDrawer-Checkout";
        if (this.checkoutButton = document.querySelector(t) || this.closest("form")?.querySelector('button[type="submit"], .button'), this.disableButton = "true" === this.dataset.disableButton, this.warningText = this.dataset.warningText, this.warningTextElement = document.querySelector(`.tnc-checkbox-warning--${this.dataset.warningPosition}-${this.dataset.section}`), !this.checkoutButton || !this.warningTextElement) return;
        this.warningTextElement && (this.warningTextElement.innerHTML = this.warningText), this.disableButton && this.checkoutButton.classList.add("disabled"), this.addEventListener("click", this.handleCheckboxClick.bind(this)), this.checkoutButton.addEventListener("click", this.handleButtonClick.bind(this))
    }
    handleCheckboxClick() {
        this.checked = !this.checked, this.dataset.checked = this.checked, this.checked ? (this.warningTextElement.classList.add("hidden"), this.disableButton && this.checkoutButton.classList.remove("disabled")) : this.disableButton && this.checkoutButton.classList.add("disabled")
    }
    handleButtonClick(t) {
        !0 !== this.checked && (t.preventDefault(), this.warningTextElement.classList.remove("hidden"))
    }
}
customElements.define("tnc-chekcbox", TncCheckbox);
class ContactForm extends HTMLElement {
    constructor() {
        super(), this.handleFormSubmit = this.handleFormSubmit.bind(this), this.handleFieldInput = this.handleFieldInput.bind(this), this.button = this.querySelector(".button"), this.tnc = this.querySelector(".tnc-checkbox")
    }
    connectedCallback() {
        this.form = this.querySelector("form"), this.form && (this.requiredFields = Array.from(this.querySelectorAll('.field-wrapper[data-required="true"]')), this.requiredFields.length > 0 && (this.form.addEventListener("submit", this.handleFormSubmit), this.requiredFields.forEach(t => {
            let e = t.querySelector(".field__input, .text-area");
            e && e.addEventListener("input", this.handleFieldInput)
        })))
    }
    disconnectedCallback() {
        this.form && this.form.removeEventListener("submit", this.handleFormSubmit), this.requiredFields.forEach(t => {
            let e = t.querySelector(".field__input, .text-area");
            e && e.removeEventListener("input", this.handleFieldInput)
        })
    }
    handleFormSubmit(t) {
        this.button && (this.button.disabled = !0, this.button.classList.add("loading"));
        let e = !0;
        if (this.tnc && "true" !== this.tnc.dataset.checked) {
            e = !1;
            let i = document.querySelector(`.tnc-checkbox-warning--${tnc.dataset.warningPosition}-${tnc.dataset.section}`);
            i && i.classList.remove("hidden")
        }
        if (this.requiredFields.forEach(t => {
                let i = t.querySelector(".field__input, .text-area"),
                    s = t.querySelector(".field-wrapper__error-msg");
                i && !i.value.trim() && (e = !1, t.classList.add("field-wrapper--error"), s && s.classList.remove("hidden"))
            }), !e) return this.button && (this.button.disabled = !1, this.button.classList.remove("loading")), t.preventDefault(), t.stopImmediatePropagation(), !1
    }
    handleFieldInput(t) {
        let e = t.target,
            i = e.closest(".field-wrapper"),
            s = i.querySelector(".field-wrapper__error-msg");
        i.classList.remove("field-wrapper--error"), s && s.classList.add("hidden")
    }
}
customElements.define("contact-form", ContactForm);
class PopupCopyButton extends CopyButton {
    constructor() {
        super(), this.copySuccessMsg = document.querySelector(".popup-modal__success-msg")
    }
    handleClick(t) {
        this.textarea.select(), document.execCommand("copy"), this.copySuccessMsg.style.display = "block"
    }
}
customElements.define("popup-copy-button", PopupCopyButton);
class PageScrollProgress extends HTMLElement {
    connectedCallback() {
        this.track = this.querySelector(".page-progress__track"), this.fill = this.querySelector(".page-progress__fill"), this.update = this.update.bind(this), window.addEventListener("scroll", this.update), window.addEventListener("resize", this.update), this.update()
    }
    update() {
        let t = document.documentElement,
            e = window.pageYOffset || t.scrollTop,
            i = t.scrollHeight - t.clientHeight;
        this.fill.style.width = (i > 0 ? Math.round(e / i * 100) : 0) + "%"
    }
}
customElements.define("page-scroll-progress", PageScrollProgress);
class DateCountdownTimer extends HTMLElement {
    connectedCallback() {
        if (this.update = this.update.bind(this), this.wrapper = this.closest(".countdown-wrapper"), !this.wrapper) return;
        let t = (this.wrapper.dataset.endTime || "").trim(),
            e = this.wrapper.dataset.timezone,
            i = parseInt(this.wrapper.dataset.utcOffset) || 0;
        if (this.behavior = this.wrapper.dataset.endBehavior, this.repeatHours = parseInt(this.wrapper.dataset.repeatHours) || 24, this.labels = {
                days: this.wrapper.dataset.labelDays,
                hours: this.wrapper.dataset.labelHours,
                minutes: this.wrapper.dataset.labelMinutes,
                seconds: this.wrapper.dataset.labelSeconds
            }, this.units = {
                days: "true" === this.wrapper.dataset.showDays,
                hours: "true" === this.wrapper.dataset.showHours,
                minutes: "true" === this.wrapper.dataset.showMinutes,
                seconds: "true" === this.wrapper.dataset.showSeconds
            }, this.timerStyle = this.dataset.style, this.endTime = this.parseEndTime(t, e, i), !(this.endTime instanceof Date) || isNaN(this.endTime.getTime())) {
            this.wrapper.style.display = "none";
            return
        }
        this.timer = setInterval(this.update, 1e3), this.update()
    }
    parseEndTime(t, e, i) {
        let s = t.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
        if (!s) {
            let n = new Date(t.replace(/-/g, "/"));
            return n
        }
        let r = parseInt(s[1], 10),
            o = parseInt(s[2], 10) - 1,
            a = parseInt(s[3], 10),
            l = parseInt(s[4], 10),
            d = parseInt(s[5], 10),
            c = parseInt(s[6] || "0", 10);
        if ("fixed" !== e) return new Date(r, o, a, l, d, c); {
            let u = Date.UTC(r, o, a, l, d, c) - 36e5 * i;
            return new Date(u)
        }
    }
    update() {
        let t = new Date,
            e = Math.floor((this.endTime - t) / 1e3);
        if (!isFinite(e)) return;
        if (e <= 0) {
            if ("hide" === this.behavior) {
                this.wrapper.style.display = "none", clearInterval(this.timer);
                return
            }
            if ("restart" === this.behavior) {
                let i = new Date(this.endTime),
                    s = 36e5 * this.repeatHours;
                for (; i <= t;) i = new Date(i.getTime() + s);
                this.endTime = i, e = Math.floor((this.endTime - t) / 1e3)
            } else if ("next_day" === this.behavior) {
                let n = new Date(this.endTime);
                for (; n <= t;) n.setDate(n.getDate() + 1);
                this.endTime = n, e = Math.floor((this.endTime - t) / 1e3)
            }
        }
        let r = Math.floor(e / 86400),
            o = Math.floor(e % 86400 / 3600),
            a = Math.floor(e % 3600 / 60),
            l = e % 60,
            d = {
                days: r,
                hours: o,
                minutes: a,
                seconds: l
            };
        Object.keys(this.units).forEach(t => {
            if (!this.units[t]) return;
            let e = this.querySelector(`[aria-label="${"days"===t?"Day":"hours"===t?"Hour":"minutes"===t?"Minute":"Second"}"]`);
            if (!e) return;
            let i = e.querySelector(".countdown-timer__number");
            if (!i) return;
            let s = String(d[t]).padStart(2, "0");
            "4" === this.timerStyle ? (i.innerHTML = "", s.split("").forEach(t => {
                let e = document.createElement("span");
                e.className = "countdown-timer__digit", e.textContent = t, i.appendChild(e)
            })) : i.textContent = s, i.setAttribute("aria-label", `${d[t]} ${this.labels[t]}`)
        })
    }
    disconnectedCallback() {
        clearInterval(this.timer)
    }
}
customElements.define("date-countdown-timer", DateCountdownTimer);
class LocalizationForm extends HTMLElement {
    constructor() {
        super(), this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            button: this.querySelector("button"),
            panel: this.querySelector(".disclosure__list-wrapper")
        }, this.elements.button.addEventListener("click", this.openSelector.bind(this)), this.addEventListener("keyup", this.onContainerKeyUp.bind(this)), this.querySelectorAll("a").forEach(t => t.addEventListener("click", this.onItemClick.bind(this))), document.addEventListener("click", this.handleClickOutside.bind(this))
    }
    hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false"), this.elements.panel.setAttribute("hidden", !0)
    }
    onContainerKeyUp(t) {
        "ESCAPE" === t.code.toUpperCase() && (this.hidePanel(), this.elements.button.focus())
    }
    onItemClick(t) {
        t.preventDefault();
        let e = this.querySelector("form");
        this.elements.input.value = t.currentTarget.dataset.value, e && e.submit()
    }
    openSelector() {
        this.elements.button.focus(), this.elements.panel.toggleAttribute("hidden"), this.elements.button.setAttribute("aria-expanded", ("false" === this.elements.button.getAttribute("aria-expanded")).toString())
    }
    handleClickOutside(t) {
        this.contains(t.target) || this.hidePanel()
    }
}
customElements.define("localization-form", LocalizationForm);
class ResultsContainer extends HTMLElement {
    constructor() {
        super(), this.styleType = this.dataset.style, this.duration = parseInt(this.dataset.duration, 10) || 650, this.initDelay = parseInt(this.dataset.delay, 10) || 0, this.observer = new IntersectionObserver(t => {
            t.forEach(t => {
                t.isIntersecting && (setTimeout(() => this.animateAll(), this.initDelay), this.observer.disconnect())
            })
        }, {
            threshold: .3
        })
    }
    connectedCallback() {
        this.observer.observe(this)
    }
    animateAll() {
        let t = this.querySelectorAll(".results__percentage");
        t.forEach(t => {
            let e = parseInt(t.dataset.percentage, 10) || 0;
            this.animateRow(t, e)
        })
    }
    animateRow(t, e) {
        let i = t.querySelector("p"),
            s = performance.now();
        if ("circle" === this.styleType) {
            let n = t.querySelector(".ring__prog");
            n && requestAnimationFrame(() => {
                n.setAttribute("stroke-dasharray", `${e} 100`)
            })
        }
        let r = t => {
            let n = Math.min((t - s) / this.duration, 1);
            i && (i.textContent = `${Math.round(n*e)}%`), n < 1 && requestAnimationFrame(r)
        };
        requestAnimationFrame(r)
    }
}
customElements.define("results-container", ResultsContainer);